<template>
  <div class="container" style="width: 98%;height: 95%;overflow: hidden;">
    <div class="filter-container">
      <el-button
          size="mini"
          class="filter-item"
          style="margin-right:0"
          icon="el-icon-menu"
          type="success"
          @click="getALLList"
      >全部
      </el-button>
      <el-button
          size="mini"
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          style="margin-left:6px"
          @click="dialogTSCXVisible = true"
      >查询
      </el-button>
      <el-button
          size="mini"
          class="filter-item"
          type="success"
          icon="el-icon-document"
          style="background:orange;border:none;margin-left:6px"
          @click="gotoBookcatalog"
      >图书编目
      </el-button>
      <el-button
          size="mini"
          class="filter-item"
          type="success"
          icon="el-icon-printer"
          style="background:#ff6a00;border:none;margin-left:6px"
          @click="btnPrint"
      >书标打印
      </el-button>
      <el-button
          size="mini"
          class="filter-item"
          type="success"
          icon="el-icon-printer"
          style="background:#ff9501;border:none;margin-left:6px"
          @click="btnBarCodePrint"
          v-show="true"
      >条码打印
      </el-button>
      <el-button
          size="mini"
          class="filter-item"
          type="success"
          icon="el-icon-setting"
          style="margin-left:6px"
          @click="btnCallNumSet"
      >索书号设置
      </el-button>
      <el-button
          v-if="!downloadLoading"
          size="mini"
          class="filter-item"
          type="info"
          icon="el-icon-download"
          style="margin-left:6px"
          @click="Download"
      >导出
      </el-button>
      <el-button
          v-if="downloadLoading"
          size="mini"
          :loading="downloadLoading"
          class="filter-item"
          type="info"
          style="margin-left:6px"
          icon="el-icon-download"
      >正在导出
      </el-button>
<!--      <el-button-->
<!--          size="mini"-->
<!--          class="filter-item"-->
<!--          style="margin-right:0; background-color: #fac904; color: white;"-->
<!--          icon="el-icon-full-screen"-->
<!--          @click="fullScreen"-->
<!--      >全 屏-->
<!--      </el-button>-->

    </div>
    <el-table
        class="book-table"
        v-loading="listLoading"
        :data="list"
        border
        :row-style="{ height: '38px' }"
        :cell-style="{ padding: '0' }"
        style="width: 100%;line-height: 0px;margin: 0px;padding: 0px 2px;"
        :height=tableHeight
        ref="table"
        @row-click="handleRowClick"
        :fit="true"
    >
<!--      <el-table-column-->
<!--          show-overflow-tooltip-->
<!--          label="批号"-->
<!--          align="center"-->
<!--          label-class-name="custom-header"-->
<!--      >-->
<!--        <template v-slot="{ row }">-->
<!--          <span >{{ row.StrLotNumber }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
          show-overflow-tooltip
          label="正题名"
          align="center"
      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrPositiveTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="图书条码"
          prop="id"
          align="center"

          show-overflow-tooltip
      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrBookBarcode }}</span>
        </template>
      </el-table-column>
      <el-table-column
          show-overflow-tooltip
          label="ISBN"
          align="center"
      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrISBN }}</span>
        </template>
      </el-table-column>
      <el-table-column
          show-overflow-tooltip
          label="分类号"

          align="center"
      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column
          show-overflow-tooltip
          label="出版社"

          align="center"
      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrPublisher }}</span>
        </template>
      </el-table-column>
      <el-table-column
          show-overflow-tooltip
          label="书屋位置"
          align="center"

      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrLibraryName }}</span>
        </template>
      </el-table-column>
      <el-table-column
          show-overflow-tooltip
          label="书架"
          align="center"

      >

        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrBookshelfName }}</span>
        </template>
      </el-table-column>

      <el-table-column
          show-overflow-tooltip
          label="第一责任者"

          align="center"
      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrFirstResponsible }}</span>
        </template>
      </el-table-column>

      <el-table-column
          show-overflow-tooltip
          label="出版日期"

          align="center"
      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrPublicationDate }}</span>
        </template>
      </el-table-column>

      <el-table-column
          show-overflow-tooltip
          label="出版地"

          align="center"
      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ row.StrPublisherPlace }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--          show-overflow-tooltip-->
<!--          label="种次号"-->

<!--          align="center"-->
<!--          prop="StrBookNumber"-->
<!--      >-->
<!--        <template v-slot="{ row }">-->
<!--          <span style="font-size: 12px;">{{ row.StrBookNumber }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--          show-overflow-tooltip-->
<!--          label="著作号"-->

<!--          align="center"-->
<!--          prop="StrBookNumber"-->
<!--      >-->
<!--        <template v-slot="{ row }">-->
<!--          <span style="font-size: 12px;">{{ row.StrAuthorNumber }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->

      <!-- <el-table-column
          show-overflow-tooltip
          label="录入日期"

          align="center"
      >
        <template v-slot="{ row }">
          <span style="font-size: 12px;">{{ new Date(row.DTCreatedDate).toLocaleDateString() }}</span>
        </template>
      </el-table-column> -->
   
      <el-table-column
          show-overflow-tooltip
          label="索书号"
          align="center"
      >
        <template v-slot="{ row }">
<!--          <span style="font-size: 12px;" v-if=false>{{ row.StrTypeName }}/{{ row.StrAuthorNumber }}</span>-->
          <span style="font-size: 12px;">{{ getPrintCallNumber(row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
          style="font-size: 12px;"
          label="操作"
          align="center"
          width="300"
          class-name="small-padding fixed-width"
          fixed="right">
        <template v-slot="{ row }">
          <el-button type="info" size="mini" @click="handleOutOld(row)"
          >剔旧
          </el-button
          >

          <el-button type="primary" size="mini" @click="handleUpdate(row)"
          >编辑
          </el-button
          >
          <el-button
              v-if="row.status != 'deleted'"
              size="mini"
              type="danger"
              @click="BookDelete(row)"
          >删除
          </el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px; text-align: right">
      <el-pagination
          background
          :total="total"
          :current-page="listQuery.Page"
          :page-size="listQuery.Perpage"
          :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
          layout="prev,pager,next,jumper,sizes,total"
          @size-change="pageSizeChange"
          @current-change="currPageChange"
      />
    </div>
    <div v-show="isFull">
      <el-tabs v-model="activeIndex">
        <el-tab-pane label="基本信息" name="1"></el-tab-pane>
        <el-tab-pane label="目录信息" name="2"></el-tab-pane>
        <el-tab-pane :label="'纸本馆藏' + '(' +opacTotal + ')'"  name="3"></el-tab-pane>
        <el-tab-pane label="电子馆藏" name="4"></el-tab-pane>
        <el-tab-pane label="数字文件" name="5"></el-tab-pane>
        <el-tab-pane label="订购记录" name="6"></el-tab-pane>
        <el-tab-pane :label="'借阅信息' + '(' +borrowPage.total + ')'" name="7"></el-tab-pane>
        <el-tab-pane :label="'赔偿记录' + '(' +dueTotal + ')'" name="8"></el-tab-pane>
        <el-tab-pane :label="'预约记录' + '(' +bookingPage.total + ')' " name="9"></el-tab-pane>
<!--        <el-tab-pane label="待定" name="9"></el-tab-pane>-->
      </el-tabs>

      <!--   TODO 内容区域-->
      <div style="margin-top: 0px" >

        <div v-if="activeIndex === '1'">
          <div class="image-text-container">
            <!-- 图片部分 -->
            <div class="demo-image__preview">
<!--              <el-image-->
<!--                  style="width: 160px; height: 225px"-->
<!--                  :src="url"-->
<!--                  :preview-src-list="srcList">-->
<!--              </el-image>-->

              <el-image
                  :src="url"
                  :preview-src-list="srcList"
                  :style="{
      'object-fit': 'contain',
      'object-position': 'center'
    }">
              </el-image>

            </div>

            <!-- 文字部分 -->
            <div class="text-column">
              <p>正题名：{{baseInfo.StrPositiveTitle}}</p>
              <p>副题目：{{baseInfo.StrSubtitle}}</p>
              <p>ISBN/定价：{{baseInfo.StrISBN}}/{{baseInfo.FloatPricePer}}</p>
              <p>条码号：{{baseInfo.StrBookBarcode}}</p>
              <p>索书号：{{baseInfo.StrCallNumber}}</p>
              <p>种次号：{{baseInfo.StrBookNumber}}</p>
              <p>每套册数：{{baseInfo.IntNumberCopies}}</p>
              <p>现存量：{{baseInfo.IntExistingStock}}</p>
              <p>装订：{{baseInfo.StrBinding}}</p>
            </div>

            <div class="text-column-right">
              <p>出版日期：{{baseInfo.StrPublicationDate}}</p>
              <p>页卷数：{{baseInfo.StrNumberPages}}</p>
              <p>出版社：{{baseInfo.StrPublisher}}</p>
              <p>出版地：{{baseInfo.StrPublisherPlace}}</p>
              <p>版本：{{baseInfo.StrVersion}}</p>
              <p>第一责任者：{{baseInfo.StrFirstResponsible}}</p>
              <p>其他责任者：{{baseInfo.StrOtherResponsible}}</p>
              <p>书屋位置：{{baseInfo.StrLibraryName}}</p>
              <p>书架：{{baseInfo.StrBookshelfName}}</p>
            </div>

            <div class="text-column-right">
              <p>批号：{{baseInfo.StrLotNumber}}</p>
              <p>分类号：{{baseInfo.StrTypeName}}</p>
              <p>分册号：{{baseInfo.StrSectionNumber}}</p>
              <p>分册名：{{baseInfo.StrSectionName}}</p>
              <p>丛书题名：{{baseInfo.StrSeriesTitle}}</p>
              <!-- <p>录入日期：{{ new Date(baseInfo.DTCreatedDate).toLocaleDateString() }}</p> -->

            </div>
          </div>
        </div>

        <div v-if="activeIndex === '3'">
          <div>
          <TableComponent :tableData="opacInfo"  :style="{ height: '300px', overflowX: 'auto',overflowY:'hidden' }"  class="custom-table"
                          :row-style="{ height: '38px' }"
                          :cell-style="{ padding: '0' }"
          >
            <template #actions="{ row }">
              <el-button type="text" @click="handleEdit(row)" style="font-size: 12px">编辑</el-button>
            </template>
          </TableComponent>
          </div>
          <el-pagination
              v-model:current-page="opacPage.currentPage"
              v-model:page-size="opacPage.pageSize"
              :total="opacTotal"
              layout="prev, pager, next"
              @size-change="handleSizeOpacChange"
              @current-change="handlePageOpacChange"
              style="margin-top: 0px; text-align: right;"
          />

        </div>

        <div v-if="activeIndex === '7'">
          <div>
            <TableBorrowComponent :tableData="borrowInfo"  :style="{ height: '300px', overflowX: 'auto',overflowY:'hidden' }" class="custom-table"
                                  :row-style="{ height: '38px' }"
                                  :cell-style="{ padding: '0' }"
            >
            </TableBorrowComponent>
            <!-- 分页组件 -->
            <div>
              <el-pagination
                  v-model:current-page="borrowPage.currentPage"
                  v-model:page-size="borrowPage.pageSize"
                  :total="borrowPage.total"
                  layout="prev, pager, next"
                  @size-change="handleSizeChange"
                  @current-change="handlePageChange"
                  style="margin-top: 0px; text-align: right;"
              />
            </div>
          </div>
        </div>

        <div v-if="activeIndex === '8'">
            <TableDueComponent :tableData="dueInfo" class="custom-table" :style="{ height: '300px', overflowX: 'auto',overflowY:'hidden' }"
                               :row-style="{ height: '38px' }"
                               :cell-style="{ padding: '0' }"
            >
              <template #actions="{ row }">
                <!-- IntStatus == 0 时显示“处理”按钮 -->
                <el-button
                    v-if="row.IntStatus === 0"
                    type="text"
                    @click="handleDeal(row)"
                    style="font-size: 12px"
                >
                  处理
                </el-button>
                <!-- IntStatus == 1 时显示“已处理”或其他按钮 -->
                <el-button
                    v-else
                    type="text"
                    disabled
                    style="font-size: 12px"
                >
                  已处理
                </el-button>
              </template>
            </TableDueComponent>
        </div>
        <div v-if="activeIndex === '2'">
          <el-empty description="暂无数据"></el-empty>
        </div>
        <div v-if="activeIndex === '4'">
          <el-empty description="暂无数据"></el-empty>
        </div>
        <div v-if="activeIndex === '5'">
          <el-empty description="暂无数据"></el-empty>
        </div>
        <div v-if="activeIndex === '6'">
          <el-empty description="暂无数据"></el-empty>
        </div>

        <div v-if="activeIndex === '9'">
          <div>
            <TableBookingComponent :table-data="bookingInfo" :style="{ height: '300px', overflowX: 'auto',overflowY:'hidden' }" class="custom-table"
                                   :row-style="{ height: '8px' }"
                                   :cell-style="{ padding: '0',margin:'0' }"
            >
              <template #actions="{ row }">
                <el-button v-show="row.AppointmentStatus !== 3 && row.AppointmentStatus !== 2 &&  row.AppointmentStatus !== 4" @click="handleCancel(row)"
                           style="font-size: 12px;padding:0;margin: 0;"
                           type="text">取消
                </el-button>
              </template>
            </TableBookingComponent>
            <!-- 分页组件 -->
            <div>
              <el-pagination
                  v-model:current-page="bookingPage.currentPage"
                  v-model:page-size="bookingPage.pageSize"
                  :total="bookingPage.total"
                  layout="prev, pager, next"
                  @size-change="handleBookingSizeChange"
                  @current-change="handleBookingPageChange"
                  style="margin-top: 0px; text-align: right;"
              />
            </div>
          </div>
        </div>

      </div>

    </div>

    <el-dialog width="32%" :title="'罚款确认'" v-model="fine" :close-on-click-modal="false">
      <p style="font-size: 18px">该书刊已超期，需缴纳罚款
        <el-input v-model="dueForm.FloatFineAmount" style="width:20%" />元</p><br>
      <el-checkbox v-model="checked">是否已缴纳罚款</el-checkbox><br>
      <div class="dialog-footer" style="float: right;">
        <el-button size="mini" @click="fine = false">取消</el-button>
        <el-button type="primary" size="mini" v-if="checked" @click="fineandreturn">完成处理</el-button>
      </div>
      <p style="color: #ffffff">三阅</p>
    </el-dialog>

    <el-dialog
        title="图书修改"
        v-model="dialogFormVisible"
        top="7vh"
        :close-on-click-modal="false"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="图书基本信息" name="first">
          <el-form
              ref="dataTsForm"
              label-width="100px"
              size="small"
              :model="formModel"
              :rules="rules"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="封面">
                  <el-upload
                      class="avatar-uploader"
                      :class="{ disabled: uploadDisabled }"
                      :headers="picheaders"
                      :data="uploadtype"
                      :action="uploadUrl"
                      list-type="picture-card"
                      :before-upload="beforeUpload"
                      :on-preview="handlePictureCardPreview"
                      :on-change="handleChange"
                      :on-remove="handleRemove"
                      :on-success="handleSuccess"
                      accept=".jpg,.jpeg,.png"
                      :file-list="fileList">
                    <i class="el-icon-plus"/>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
<!--                ISBN查询功能-->
                <el-form-item label="联网检索：">
                  <el-input v-model="formCXTSModel.keywords" placeholder="请输入ISBN或图书标题，点击回车后搜索" @keydown.enter="bookSearch"/>
                </el-form-item>


                <el-form-item label="正题名" prop="StrPositiveTitle">
                  <el-input v-model="formModel.StrPositiveTitle"/>
                </el-form-item>
                <el-form-item label="附件" prop="title">
                  <el-input v-model="formModel.StrAffix"/>
                </el-form-item>
                <el-form-item label="第一责任者" prop="StrFirstResponsible">
                  <el-input v-model="formModel.StrFirstResponsible"/>
                </el-form-item>
                <el-form-item label="其他责任者" prop="title">
                  <el-input v-model="formModel.StrOtherResponsible"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="副题名">
                  <el-input v-model="formModel.StrSubtitle"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="丛书题名">
                  <el-input v-model="formModel.StrSeriesTitle"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="版本">
                  <el-input v-model="formModel.StrVersion"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="分册号">
                  <el-input v-model="formModel.StrSectionNumber"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="装订">
                  <el-input v-model="formModel.StrBinding"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="主题词">
                  <el-input v-model="formModel.StrKeywords"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="出版社">
                  <el-input v-model="formModel.StrPublisher"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="出版日期">
                  <el-input v-model="formModel.StrPublicationDate"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="卷页数">
                  <el-input v-model="formModel.StrNumberPages"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="出版地">
                  <el-input v-model="formModel.StrPublisherPlace"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="StrISBN" label="ISBN">
                  <el-input v-model="formModel.StrISBN"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="每套册数">
                  <el-input v-model="formModel.IntNumberCopies"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="StrTypeName" label="分类号">
                  <el-input v-model="formModel.StrTypeName" @blur="check"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="预定册数">
                  <el-input v-model="formModel.IntOrderNumber"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="StrBookNumber" label="种次号" :rules="rules.StrBookNumber">
                  <el-input v-positive-number type="number"  v-model="formModel.StrBookNumber"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="卷册">
                  <el-input v-model="formModel.StrSectionName"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="FloatPricePer" label="分册价格">
                  <el-input v-model="formModel.FloatPricePer"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="StrBookBarcode" label="条形码">
                  <el-input v-model="formModel.StrBookBarcode"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="书本简介">
                  <el-input v-model="formModel.StrSummary"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>



        <el-tab-pane label="书屋信息" name="second">
          <el-form label-width="150px" size="small" :model="formModel">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="title" label="书屋位置">
                  <el-select
                      v-model="formModel.StrLibraryID"
                      class="filter-item"
                      placeholder="请选择"
                      @change="selectSW"
                      :disabled="true"
                  >
                    <el-option
                        v-for="item in swList"
                        :key="item.StrID"
                        :label="item.StrName"
                        :value="item.StrID"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="title" label="书架">
                  <el-select
                      v-model="formModel.StrBookshelfID"
                      class="filter-item"
                      placeholder="请选择"
                      :disabled="true"
                  >
                    <el-option
                        v-for="item in bookshelfs"
                        :key="item.StrID"
                        :label="item.StrName"
                        :value="item.StrID"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="录入日期" prop="title">
                  <el-input v-model="formModel.DTCreatedDate" readonly="true"/>
                </el-form-item>
              </el-col> -->

              <el-col :span="12">
                <el-form-item label="借阅次数" prop="title">
                  <el-input
                      v-model="formModel.IntBorrowedCount"
                      readonly="true"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否出借" prop="title">
                  <el-input v-model="formModel.IsBorrowed" readonly="true"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="当前库存" prop="title">
                  <el-input
                      v-model="formModel.IntExistingStock"
                      readonly="true"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="当前借阅者" prop="title">
                  <el-input
                      v-model="formModel.currentReaerName"
                      readonly="true"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="读者卡号" prop="title">
                  <el-input
                      v-model="formModel.currentReaerNumber"
                      readonly="true"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="此类丢失" prop="title">
                  <el-input v-model="formModel.IsLost" readonly="true"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="此类损毁" prop="title">
                  <el-input v-model="formModel.IsBroken" readonly="true"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div style="float: right; border: 10px">
        <el-button size="mini" @click="dialogFormVisible = false"
        >取消
        </el-button
        >
        <el-button type="primary" size="mini" @click="updateData"
        >确定
        </el-button
        >
      </div>
      <p style="color: #ffffff">三阅</p>
    </el-dialog>

    <el-dialog
        title="图书查询结果"
        v-model="dialogCXJGVisible"
        top="7vh"
        :close-on-click-modal="false">
      <el-table
          v-loading="cxjgLoading"
          :data="cxjgList"
          border
          fit
          highlight-current-row
          style="width: 100%">
        <el-table-column label="正题名" align="center" width="200px">
          <template v-slot="{ row }">
            <span>{{ row.StrPositiveTitle }}</span>
          </template>
        </el-table-column>

        <el-table-column label="分类号/种次号" align="center" width="170px">
          <template v-slot="{ row }">
            <span>{{ row.StrCallNumber }}</span>
          </template>
        </el-table-column>

        <el-table-column label="ISBN" align="center" width="170px">
          <template v-slot="{ row }">
            <span>{{ row.StrISBN }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template v-slot="{ row }">
            <el-button type="primary" size="mini" @click="BookUpdate(row)"
            >选择
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right">
        <el-pagination
            background
            :total="tsTotal"
            :current-page="cxjgQuery.Page"
            :page-size="cxjgQuery.Perpage"
            layout="prev,pager,next,total"
            @size-change="cxjgPageSizeChange"
            @current-change="cxjgCurrPageChange"
        />
      </div>
    </el-dialog>
    <!-- 图片预览 -->
    <el-dialog title="图片预览" width="40%" v-model="showPictureCardPreview">
      <div style="text-align: center">
        <img :src="showImg"/>
      </div>
    </el-dialog>
    <el-dialog
        title="图书查询"
        width="40%"
        v-model="dialogTSCXVisible"
        :close-on-click-modal="false"
    >
      <el-form label-width="150px" size="small" :model="search">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="ISBN" prop="title">
              <el-input v-model="search.StrISBN"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="作者" prop="title">
              <el-input v-model="search.StrFirstResponsible"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="正题名" prop="title">
              <el-input v-model="search.StrPositiveTitle"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="图书条码" prop="title">
              <div style="display: flex">
                <el-input v-model="search.StrBookBarcode" size="mini"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="图书分类" prop="title">
              <el-input v-model="search.StrTypeName"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="编目日期" prop="title">
              <el-config-provider :locale="zhCn">
              <el-date-picker
                  v-model="search.DTStartCreatedDate"
                  type="date"
                  placeholder="选择日期"
                  :disabled-date="disabledDate"
                  @change = "choose"
              />
              至
              <el-date-picker
                  v-model="search.DTEndCreatedDate"
                  type="date"
                  placeholder="选择日期"
                  :disabled-date="disabledDate"
                  @change = "choose"
              />
              </el-config-provider>

            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="书屋位置" prop="title">
              <el-select v-model="search.StrLibraryID" placeholder="请选择">
                <el-option
                    v-for="item in swList"
                    :key="item.StrID"
                    :label="item.StrName"
                    :value="item.StrID"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span class="dialog-footer" style="float: right">
        <el-button size="mini" @click="dialogTSCXVisible = false"
        >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="handleFilter"
        >确 定</el-button
        >
      </span>
      <p style="color: #ffffff">三阅</p>
    </el-dialog>
    <!-- 书标条码打印 -->
    <el-dialog title="选择打印" v-model="dialogVisible" width="410px" top="22vh">
      <el-form ref="formLableCode" :model="formLableCode" :rules="ruleCode" label-width="100px">
        <el-form-item label="打印方式：">
          <el-select v-model="formLableCode.type" size="small" placeholder="请选择打印类型">
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="书标方案：">
          <el-radio-group v-model="printScheme" size="small">
            <el-radio label="1">种次号</el-radio>
            <el-radio label="2">著作号</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="formLableCode.type === 1">
          <el-form-item label="批号编目：" prop="StrLotNumber">
            <el-select v-model="formLableCode.StrLotNumber" size="small" placeholder="请选择批号" @change="bookDataList">
              <el-option v-for="(item, index) in batchList" :key="index" :label="item.StrLotNumber"
                         :value="item.StrLotNumber"/>
            </el-select>
          </el-form-item>
          <div v-if="formLableCode.StrLotNumber">
            <p style="margin-left: 100px; color: red; font-size: 14px">
              当前共
              <span style="color: black">{{ total }}</span>
              条数据，请选择打印区间
            </p>
          </div>
          <el-form-item v-if="formLableCode.StrLotNumber && total !== 0" label="批号条数：" required>
            <el-col :span="11">
              <el-form-item prop="Start">
                <el-input v-model="formLableCode.Start" type="number" min="1" :max="batchTotal" placeholder="开始条数"
                          size="small"/>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: center">
              <span>&nbsp;至&nbsp;</span>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="End">
                <el-input v-model="formLableCode.End" type="number" :min="parseInt(formLableCode.Start)"
                          :max="batchTotal" placeholder="结束条数" size="small"/>
              </el-form-item>
            </el-col>
          </el-form-item>
        </div>
        <div v-if="formLableCode.type === 2">
          <el-form-item label="批号编目：" prop="StrLotNumber">
            <el-select v-model="formLableCode.StrLotNumber" size="small" placeholder="请选择批号" @change="bookDataList">
              <el-option v-for="(item, index) in batchList" :key="index" :label="item.StrLotNumber"
                         :value="item.StrLotNumber"/>
            </el-select>
          </el-form-item>
          <div v-if="formLableCode.StrLotNumber">
            <p style="margin-left: 100px; color: red; font-size: 14px">请填写打印条码区间</p>
          </div>
          <el-form-item v-if="formLableCode.StrLotNumber && total !== 0" label="起始条码：" required>
            <el-col :span="11">
              <el-form-item prop="StrStartBookBarcode">
                <el-input v-model="formLableCode.StrStartBookBarcode" placeholder="开始条码" size="small"/>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: center">
              <span>&nbsp;至&nbsp;</span>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="StrEndBookBarcode">
                <el-input v-model="formLableCode.StrEndBookBarcode" placeholder="结束条码" size="small"/>
              </el-form-item>
            </el-col>
          </el-form-item>
        </div>

        <div v-if="formLableCode.type === 3">
          <el-form-item label="条码：" prop="bookMarkBarCode">
            <el-input v-model="formAnother.bookMarkBarCode" placeholder="请输入条码" size="small" @keydown.native="preventChineseComma"
                      @paste.native="handlePaste" style="width: 210px;" />
            <span style="color: red;font-size: 12px;font-weight: bold;display: inline-block; line-height: 1;  margin: 0;padding: 0;">请将要替换的条码号填在输入框中，如果有多个条码请用逗号','隔开</span>
          </el-form-item>
        </div>
      </el-form>
      <span class="dialog-footer" style="float: right; border: 10px">
        <el-button size="small" @click="closeLableCode">取 消</el-button>
        <el-button size="small" type="primary" @click="labelCodeSure('formLableCode')">确 定</el-button>
      </span>
      <p style="color: #ffffff">三阅</p>
    </el-dialog>

    <!-- 书标条码打印 -->
    <el-dialog title="设置" v-model="dialogVisibleSet" width="560px" top="22vh">
      <el-form
          ref="formStyleSet"
          :model="formStyleSet"
          :rules="ruleCode"
          label-width="100px"
      >
        <el-form-item label="打印类型：">
          <el-select
              v-model="formStyleSet.type"
              size="small"
              placeholder="请选择打印类型"
              @change="typeChange"
          >
            <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.label"
                :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="Start">
          <el-input
              v-model="formStyleSet.Start"
              type="number"
              min="1"
              :max="batchTotal"
              placeholder="开始条数"
              size="small"
          />
        </el-form-item>
      </el-form>
      <span class="dialog-footer">
        <el-button size="small" @click="dialogVisibleSet = false"
        >取 消</el-button
        >
        <el-button size="small" type="primary" @click="styleSet('formStyleSet')"
        >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 书标条码打印样式设置 -->
    <el-dialog
        title="书标打印参数设置"
        v-model="dialogVisiblePrint"
        width="700px"
        top="22vh"
    >
      <div>打印布局设置（单位：mm）</div>
      <ul class="print-set">
        <li class="print-set-item">
          <div class="print-set-title">纸张</div>
          <div class="print-set-option" style="text-align: left;">宽度</div>
          <el-input
              v-model="printSet.width"
              type="number"
              :min="1"
              size="mini"
              style="width: 70px;margin-left: -30px"/>
          <div class="print-set-option">高度</div>
          <el-input
              v-model="printSet.height"
              type="number"
              :min="1"
              size="mini"
              style="width: 70px;text-align: left"/>
        </li>
        <li class="print-set-item">
          <div class="print-set-title">书标排版</div>
          <div class="print-set-option" style="text-align: left;">行数</div>
          <el-input
              v-model="printSet.row"
              type="number"
              :min="1"
              size="mini"
              style="width: 71px;margin-left: -30px"
          />
          <div class="print-set-option">列数</div>
          <el-input
              v-model="printSet.col"
              type="number"
              :min="1"
              size="mini"
              style="width: 70px;text-align: left"
          />

          <div class="print-set-option">内边距</div>
          <el-input
              v-model="printSet.gap"
              type="number"
              :min="1"
              size="mini"
              style="width: 70px;text-align: left"
          />
        </li>
        <li class="print-set-item">
          <div class="print-set-title" style="text-align: left;">书标区域</div>
          <div class="print-set-option" style="text-align: left;">上边距</div>
          <el-input
              v-model="printSet.paddingTop"
              type="number"
              :min="0"
              size="mini"
              style="width: 70px;margin-left: -20px"
          />
          <div class="print-set-option">下边距</div>
          <el-input
              v-model="printSet.paddingBottom"
              type="number"
              :min="0"
              size="mini"
              style="width: 70px"
          />
          <div class="print-set-option">左边距</div>
          <el-input
              v-model="printSet.paddingLeft"
              type="number"
              :min="0"
              size="mini"
              style="width: 70px"
          />
          <div class="print-set-option">右边距</div>
          <el-input
              v-model="printSet.paddingRight"
              type="number"
              :min="0"
              size="mini"
              style="width: 70px"
          />
        </li>
        <li class="print-set-item">
          <div class="print-set-title">内容排列</div>
          <div class="print-set-option" style="text-align: left;">垂直</div>
          <el-select
              v-model="printSet.verticalAlign"
              size="mini"
              style="width: 120px;margin-left: -30px"
          >
            <el-option label="顶部对齐" value="flex-start"/>
            <el-option label="居中对齐" value="center"/>
            <el-option label="底部对齐" value="flex-end"/>
          </el-select>
          <div class="print-set-option">水平</div>
          <el-select
              v-model="printSet.horizontalAlign"
              size="mini"
              style="width: 120px"
          >
            <el-option label="水平居中" value="center"/>
            <el-option label="左对齐" value="left"/>
            <el-option label="右对齐" value="right"/>
          </el-select>
        </li>
        <li class="print-set-item">
          <div class="print-set-title" style="text-align: left;">条码位置</div>
          <div style="text-align:left;margin-left: -35px">
            <el-radio v-model="printSet.overturn" label="1" style="margin-left: 40px;">上</el-radio>
            <el-radio v-model="printSet.overturn" label="2">下</el-radio>
          </div>
        </li>
        <li class="print-set-item">
          <div class="print-set-title" style="text-align: left;">条码显示</div>
          <div style="text-align:left;margin-left: -35px">
            <el-radio v-model="printSet.showBarcode" label="1" style="margin-left: 40px;">显示</el-radio>
            <el-radio v-model="printSet.showBarcode" label="0">隐藏</el-radio>
          </div>
        </li>
        <li class="print-set-item">
          <div class="print-set-title">其他</div>
          <div class="print-set-option" style="text-align: left;">字号</div>
          <el-select
              v-model="printSet.fontSize"
              size="mini"
              style="width: 120px;margin-left: -30px"
          >
            <el-option
                v-for="item in [
                10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
                26,
              ]"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
          <div class="print-set-option">行高</div>
          <el-select
              v-model="printSet.lineHeight"
              size="mini"
              style="width: 120px">
            <el-option
                v-for="item in [16, 18, 20, 22, 24, 26, 28, 30]"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
          <div class="print-set-option" style="margin-left: 10px">学校字号</div>
          <el-select
              v-model="printSet.nameFontSize"
              size="mini"
              style="width: 120px;"
          >
            <el-option
                v-for="item in [
                5,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
                26,
              ]"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </li>

        <li class="print-set-item">
          <div class="print-set-title">学校名称</div>
          <div class="print-set-option" style="text-align: left;">名称</div>
          <el-input
              v-model="printSet.name"
              type="text"
              :min="1"
              size="mini"
              style="width: 160px;margin-left: -30px"/>

          <div class="print-set-option">位置</div>
          <div style="text-align:left;margin-left: -35px">
            <el-radio v-model="printSet.location" label="1" style="margin-left: 40px;">顶部</el-radio>
            <el-radio v-model="printSet.location" label="2">底部</el-radio>
          </div>
        </li>

      </ul>
      <div
          v-show="preview"
          class="print-box"
          :style="{ transform: `scale(${scale / 100})` }"
      >
        <div ref="print">
          <div
              :style="{
              width: `${printSet.width}mm`,
              paddingTop: `${printSet.paddingTop}mm`,
              paddingBottom: `${printSet.paddingBottom}mm`,
              paddingLeft: `${printSet.paddingLeft}mm`,
              paddingRight: `${printSet.paddingRight}mm`,
            }"
          >
            <div
                v-for="(item, index) in printListFilter"
                :key="index"
                style="display: inline-block"
                :style="{
                textAlign: `center`,
                width: `${(printSet.width-printSet.paddingLeft-printSet.paddingRight)/printSet.col-0.05}mm`,
                height: `${(printSet.height-printSet.paddingTop-printSet.paddingBottom)/printSet.row-0.05}mm`,
                textAlign: printSet.horizontalAlign,
                lineHeight: `${printSet.lineHeight}px`,
                fontSize: `${printSet.fontSize}px`,
                paddingTop:`${printSet.gap}mm`
              }"
            >
              <div
                  style="display: flex; flex-direction: column; height: 100%"
                  :style="{
                    justifyContent: printSet.verticalAlign
                     }">
                <template v-if="printSet.overturn==='1'">
                  <div v-if="printSet.location === '1'">
                    <div :style="{ fontSize: `${printSet.nameFontSize}px` }">{{ printSet.name }}</div>
                    <div v-show="printSet.showBarcode === '1'">{{ item.StrBookBarcode }}</div>
                    <div v-if="printScheme === '2'" v-html="getPrintCallNumberHtml(item)"></div>
                    <div v-else>{{ getPrintCallNumber(item) }}</div>
                  </div>

                  <div v-else>
                    <div v-show="printSet.showBarcode === '1'">{{ item.StrBookBarcode }}</div>
                    <div v-if="printScheme === '2'" v-html="getPrintCallNumberHtml(item)"></div>
                    <div v-else>{{ getPrintCallNumber(item) }}</div>
                    <div :style="{ fontSize: `${printSet.nameFontSize}px` }">{{ printSet.name }}</div>
                  </div>

                </template>
                <template v-else>
                  <div v-if="printSet.location === '1'">
                    <div :style="{ fontSize: `${printSet.nameFontSize}px` }">{{ printSet.name }}</div>
                    <div v-if="printScheme === '2'" v-html="getPrintCallNumberHtml(item)"></div>
                    <div v-else>{{ getPrintCallNumber(item) }}</div>
                    <div v-show="printSet.showBarcode === '1'">{{ item.StrBookBarcode }}</div>
                  </div>

                  <div v-else>
                    <div v-if="printScheme === '2'" v-html="getPrintCallNumberHtml(item)"></div>
                    <div v-else>{{ getPrintCallNumber(item) }}</div>
                    <div v-show="printSet.showBarcode === '1'">{{ item.StrBookBarcode }}</div>
                    <div :style="{ fontSize: `${printSet.nameFontSize}px` }">{{ printSet.name }}</div>
                  </div>

                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p style="color: #ffffff">三阅</p>
      <div
          class="dialog-footer"
          style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="dialog-footer" style="float: right; border: 10px">
          <el-button size="small" @click="dialogVisiblePrint = false">取 消</el-button>
          <el-button size="small" type="primary" plain @click="resetPrint()">还 原</el-button>
          <span style="margin-left:12px; color:black;">本次共选择{{ printListSize }}条数据</span>
        </div>
        <div style="display: flex; align-items: center">
          <div
              v-show="preview"
              style="display: flex; align-items: center; margin-right: 10px"
          >
            <span style="font-size: 12px">预览缩放：</span>
            <el-slider
                v-model="scale"
                :format-tooltip="(val) => val / 100"
                style="width: 120px"
            />
          </div>
          <el-button
              size="small"
              type="success"
              plain
              @click="preview = !preview"
          >预 览
          </el-button
          >
          <el-button size="small" type="primary" @click="printTrue"
          >打 印
          </el-button
          >
        </div>
      </div>
    </el-dialog>


    <!-- 条码打印，最后一个按钮 -->
<!--    <el-dialog title="选择打印" v-model="dialogBarCodeVisible" width="410px" top="22vh">-->
<!--      <el-form ref="formBarCode" :model="formBarCode" :rules="ruleBarCode" label-width="100px">-->
<!--        <el-form-item label="馆名称：" prop="lirName">-->
<!--          <el-col :span="23">-->
<!--            <el-input v-model="formBarCode.lirName" placeholder="请输入馆名称" size="small"/>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="条码长度：" prop="barCodeLen">-->
<!--          <el-col :span="23">-->
<!--            <el-input v-model="formBarCode.barCodeLen" type="number" min="1" placeholder="请输入条码长度" size="small"/>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="开始条码：" prop="beginBarCode">-->
<!--          <el-col :span="23">-->
<!--            <el-input v-model="formBarCode.beginBarCode" placeholder="请输入开始条码" size="small"/>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="条码个数：" prop="barCodeNum">-->
<!--          <el-col :span="23">-->
<!--            <el-input v-model="formBarCode.barCodeNum" type="number" min="1" placeholder="请输入条码个数" size="small"/>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--      <span class="dialog-footer" style="float: right; border: 10px">-->
<!--        <el-button size="small" @click="closeLableCode">取 消</el-button>-->
<!--        <el-button size="small" type="primary" @click="barCodeSure">确 定</el-button>-->
<!--      </span>-->
<!--      <p style="color: #ffffff">三阅</p>-->
<!--    </el-dialog>-->

<!--    NEW 条码打印-->
    <el-dialog title="选择打印" v-model="dialogBarCodeVisible" width="410px" top="22vh">
      <el-form label-width="100px">
        <el-form-item label="选择表单：">
          <el-radio-group v-model="activeForm">
            <el-radio label="form1">批量打印</el-radio>
            <el-radio label="form2">剔旧打印</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-form v-if="activeForm === 'form1'" ref="formBarCode" :model="formBarCode" :rules="ruleBarCode" label-width="100px">
        <el-form-item label="馆名称：" prop="lirName">
          <el-col :span="23">
            <el-input v-model="formBarCode.lirName" placeholder="请输入馆名称" size="small"/>
          </el-col>
        </el-form-item>
        <el-form-item label="条码长度：" prop="barCodeLen">
          <el-col :span="23">
            <el-input v-model="formBarCode.barCodeLen" type="number" min="1" placeholder="请输入条码长度" size="small"/>
          </el-col>
        </el-form-item>
        <el-form-item label="开始条码：" prop="beginBarCode">
          <el-col :span="23">
            <el-input v-model="formBarCode.beginBarCode" placeholder="请输入开始条码" size="small"/>
          </el-col>
        </el-form-item>
        <el-form-item label="条码个数：" prop="barCodeNum">
          <el-col :span="23">
            <el-input v-model="formBarCode.barCodeNum" type="number" min="1" placeholder="请输入条码个数" size="small"/>
          </el-col>
        </el-form-item>
      </el-form>
      <el-form v-else ref="formAnother" :model="formAnother" label-width="100px">
        <el-form-item label="馆名称：" prop="libName">
          <el-col :span="23">
            <el-input v-model="formAnother.libName" placeholder="请输入馆名称" size="small"/>
          </el-col>
        </el-form-item>
        <el-form-item label="条码：" prop="anotherField" >
          <el-col :span="17">
            <el-input v-model="formAnother.anotherField" placeholder="请输入条码" size="small"  @keydown.native="preventChineseComma"
                      @paste.native="handlePaste"/>
            <span style="color: red;font-size: 12px;font-weight: bold;display: inline-block; line-height: 1;  margin: 0;padding: 0;">请将要替换的条码号填在输入框中，如果有多个条码请用逗号','隔开</span>
          </el-col>
        </el-form-item>
      </el-form>
      <span class="dialog-footer" style="float: right; border: 10px">
      <el-button size="small" @click="closeLableCode">取 消</el-button>
      <el-button size="small" type="primary" @click="barCodeSure">确 定</el-button>
    </span>
      <p style="color: #ffffff">三阅</p>
    </el-dialog>

    <el-dialog title="索书号设置" v-model="dialogCallNumVisible" width="410px" top="22vh" :close-on-click-modal="false">
      <el-form label-width="100px">
        <el-form-item label="索书号：">
          <el-radio-group v-model="callNumType">
            <el-radio label="1">种次号</el-radio>
            <el-radio label="2">著作号</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span class="dialog-footer" style="float: right; border: 10px">
        <el-button size="small" @click="dialogCallNumVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="callNumSetSure">确 定</el-button>
      </span>
      <p style="color: #ffffff">三阅</p>
    </el-dialog>

    <el-dialog
        title="条码打印参数设置"
        v-model="dialogVisiblePrintCodeBar"
        width="700px"
        top="22vh">
      <div>打印布局设置</div>
      <ul class="print-set">
        <li class="print-set-item">
          <div class="print-set-title">纸张</div>
          <div class="print-set-option">宽度</div>
          <el-input
              v-model="printSetBarCode.width"
              type="number"
              :min="1"
              size="mini"
              style="width: 70px"
          />
        </li>
        <li class="print-set-item">
          <div class="print-set-title">条码</div>
          <div class="print-set-option">高度</div>
          <el-input
              v-model="printSetBarCode.barCodeHeight"
              type="number"
              :min="1"
              size="mini"
              style="width: 70px"
          />
          <div class="print-set-option">列数</div>
          <el-input
              v-model="printSetBarCode.columns"
              type="number"
              :min="1"
              size="mini"
              style="width: 70px"
          />
          <div class="print-set-option">水平间距</div>
          <el-input
              v-model="printSetBarCode.marginLeft"
              type="number"
              :min="0"
              size="mini"
              style="width: 70px"
          />
          <div class="print-set-option">垂直间距</div>
          <el-input
              v-model="printSetBarCode.marginTop"
              type="number"
              :min="0"
              size="mini"
              style="width: 70px"
          />
        </li>

        <li class="print-set-item">
          <div class="print-set-title">内容排列</div>
          <div class="print-set-option">垂直</div>
          <el-select
              v-model="printSetBarCode.verticalAlign"
              size="mini"
              style="width: 120px"
          >
            <el-option label="顶部对齐" value="flex-start"/>
            <el-option label="居中对齐" value="center"/>
            <el-option label="底部对齐" value="flex-end"/>
          </el-select>
          <div class="print-set-option">水平</div>
          <el-select
              v-model="printSetBarCode.horizontalAlign"
              size="mini"
              style="width: 120px"
          >
            <el-option label="水平居中" value="center"/>
            <el-option label="左对齐" value="left"/>
            <el-option label="右对齐" value="right"/>
          </el-select>
        </li>
        <li class="print-set-item">
          <div class="print-set-title">其他</div>
          <div class="print-set-option">字号</div>
          <el-select
              v-model="printSetBarCode.fontSize"
              size="mini"
              style="width: 120px"
          >
            <el-option
                v-for="item in [
                10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
                26,
              ]"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
          <div class="print-set-option">行高</div>
          <el-select
              v-model="printSetBarCode.lineHeight"
              size="mini"
              style="width: 120px"
          >
            <el-option
                v-for="item in [16, 18, 20, 22, 24, 26, 28, 30]"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </li>
      </ul>
      <div
          v-show="previewBarCode"
          class="print-box"
          :style="{ transform: `scale(${scaleBarCode / 100})` }"
      >
        <div ref="printBarCode">
          <div
              :style="{
              // textAlign: `center`,
              width: `${printSetBarCode.width-1-printSetBarCode.paddingLeft-printSetBarCode.paddingRight}mm`,
              paddingTop: `${printSetBarCode.paddingTop}mm`,
              paddingBottom: `${printSetBarCode.paddingBottom}mm`,
              paddingLeft: `${printSetBarCode.paddingLeft}mm`,
              paddingRight: `${printSetBarCode.paddingRight}mm`,
            }"
          >
            <div
                v-for="(item, index) in printListFilterBarCode"
                :key="index"
                style="display: inline-block"
                :style="{
                width: `${(printSetBarCode.width-printSetBarCode.paddingLeft-printSetBarCode.paddingRight) / printSetBarCode.columns-printSetBarCode.marginLeft-0.05}mm`,
                height: `${printSetBarCode.barCodeHeight}mm`,
                marginLeft: `${(index===0||index%printSetBarCode.columns===0)?0:printSetBarCode.marginLeft}mm`,
                marginTop: `${printSetBarCode.marginTop}mm`,
                textAlign: printSetBarCode.horizontalAlign,
                lineHeight: `${printSetBarCode.lineHeight}px`,
                fontSize: `${printSetBarCode.fontSize}px`,
              }">
              <div
                  style="display: flex; flex-direction: column; height: 100%"
                  :style="{ justifyContent: printSetBarCode.verticalAlign }">
                <div>{{ item.lirName }}</div>
                <img :src="item.img">
                <div>{{ item.barCode }}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <p style="color: #ffffff">三阅</p>
      <div
          class="dialog-footer"
          style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="dialog-footer" style="float: right; border: 10px">
          <el-button size="small" @click="dialogVisiblePrintCodeBar = false"
          >取 消
          </el-button
          >
          <el-button size="small" type="primary" plain @click="resetPrintBarCode()"
          >还 原
          </el-button
          >
          <span style="margin-left:12px; color:black;">本次共选择{{ printListSizeBarCode }}条数据</span>
        </div>
        <div style="display: flex; align-items: center">
          <div
              v-show="previewBarCode"
              style="display: flex; align-items: center; margin-right: 10px"
          >
            <span style="font-size: 12px">预览缩放：</span>
            <el-slider
                v-model="scaleBarCode"
                :format-tooltip="(val) => val / 100"
                style="width: 120px"
            />
          </div>
          <el-button
              size="small"
              type="success"
              plain
              @click="previewBarCode = !previewBarCode">预 览
          </el-button>
          <el-button size="small" type="primary" @click="printTrueBarCode"
          >打 印
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import global from "@/utils/global";
import md5 from "js-md5";
import Compressor from "compressorjs";
import TableComponent from "./TableComponent.vue";
import TableBorrowComponent from "./TableBorrowComponent.vue";
import TableDueComponent from "./TableDueComponent.vue";
import TableBookingComponent from "./TableBookingComponent.vue";

import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import {ElMessage} from "element-plus";
import {BASE_URL} from "@/utils/constants";
import JsBarcode from "jsbarcode";
export default {
  name: "bookfile",
  components: {TableBookingComponent, TableBorrowComponent, TableComponent, TableDueComponent},
  data() {
    return {
      allBookBarcodeLengths:[],
      bookHouseData:[],
      totalBookHouseCount:0,
      activeForm: 'form1',
      formAnother: {
        anotherField: '',
        libName:'',
        bookMarkBarCode:''
      },
      cxjgQuery: {
        Page: 1,
        Pager: 10,
      },
      tsTotal: 0,
      cxjgLoading: true,
      dialogCXJGVisible: false,
      cxjgList: [],
      formCXTSModel: {
        pageIndex: 1,
        pageSize: 10,
        keyName: "StrISBN",
        keywords: "",
      },
      bookingPage:{
        total:0,
        currentPage: 1,
        pageSize: 10,
      },
      bookingInfo:[],
      tableHeight:550,
      opacPage:{
        currentPage:1,
        pageSize:10,
      },
      dueForm:{
        FloatFineAmount:'',
        StrID:'',
        StrBookBarcode:''
      },
      fine:false,
      checked:false,
      borrowPage:{
        total:0,
        currentPage: 1,
        pageSize: 10,
      },
      pageISBN:'',
      pageCode:'',
      opacTotal:0,
      dueTotal:0,
      isFull:true,
      dueInfo:[],//接超期罚款信息
      borrowInfo:[],//接借阅信息
      opacInfo:[],//接opac查询的数据
      baseInfo:{
        id:'',
        created_at:"",
        updated_at:"",
        StrID:"",
        StrOrganizationID:"",
        StrPositiveTitle:"",
        StrFirstResponsible:"",
        StrOtherResponsible:"",
        StrVersion:"",
        StrSummary:"",
        StrSectionNumber:'',
        StrSectionName:'',
        StrSubtitle:'',
        StrSeriesTitle:'',
        StrTypeName:'',
        IsCLC:'',
        IntNumberCopies:'',
        IntBorrowedCount:'',
        StrBinding:'',
        StrNumberPages:'',
        StrPublicationDate:'',
        StrPublisher:'',
        StrPublisherPlace:'',
        StrISBN:'',
        StrBookNumber:'',
        StrLotNumber:'',
        StrLotNumberID:'',
        StrBookBarcode:'',
        StrLibraryID:'',
        StrLibraryName:'',
        StrBookshelfID:'',
        StrBookshelfName:'',
        IntExistingStock:'',
        IntIsLogoff:'',
        StrCallNumber:'',
        FloatPricePer:'',
        StrParallelTitle:'',
        StrKeywords:'',
        StrRemark:'',
        IsLost:'',
        IsBroken:'',
        IsBorrowed:'',
        OnShelf:'',
        StrParticiple:'',
        StrTranslator:'',
        StrAuxiliaryNum:'',
        StrSizeFormat:'',
        StrAffixL:'',
        StrCurrencyUnit:'',
        StrRMB:'',
        StrLoginID:'',
        IntTotalInventory:'',
        IntNumberLoans:'',
        IntPrintLocation:'',
        StrCategoryName:'',
        StrSearchKey:'',
        IntFrontCover:'',
        StrCoverURL:'',
        StrCreatorID:'',
        StrCreatorName:'',
        DTCreatedDate:'',
        StrSource:'',
        IntOrderNumber:''
      },
      url:require('../../assets/img/defaultBook.png'),
      srcList: [],
      activeIndex: '1',
      StrLotNumber: "", // 批号
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        Page: 1,
        Perpage: 10,
        intNotOn: "1",
        Sort: "-1",
        OrderBy: "DTCreatedDate"
      },
      // disable: true, // 书架
      dialogFormVisible: false,
      dialogStatus: "",
      formSJModel: {},
      //表单验证
      ruleCode: {
        StrLotNumber: [
          {required: true, message: "请选择批号", trigger: "blur"},
        ],
        Start: [{required: true, message: "请填写开始条数", trigger: "blur"}],
        End: [{required: true, message: "请填写结束条码", trigger: "blur"}],
        StrStartBookBarcode: [
          {required: true, message: "请填写开始条码", trigger: "blur"},
        ],
        StrEndBookBarcode: [
          {required: true, message: "请填写结束条码", trigger: "blur"},
        ],
      },

      rules: {
        StrLibraryID: [
          {required: true, message: "请选择书屋", trigger: "chanage"},
        ],
        StrBookshelfID: [
          {required: true, message: "请选择书架", trigger: "chanage"},
        ],
        StrPositiveTitle: [
          {required: true, message: "请输入正题名", trigger: "blur"},
        ],
        StrFirstResponsible: [
          {required: true, message: "请输入第一责任者", trigger: "blur"},
        ],
        StrTypeName: [
          {required: true, message: "请输入分类号", trigger: "blur"},
        ],
        StrISBN: [{required: true, message: "请输入ISBN", trigger: "blur"}],
        StrBookBarcode: [
          {required: true, message: "请输入条形码", trigger: "blur"},
        ],
        FloatPricePer: [
          {required: true, message: "请输入每册价格", trigger: "blur"},
        ],
        StrBookNumber: [
          {
            type: 'number',
            validator: (rule, value, callback) => {
              // 允许空值（null, undefined, 空字符串）
              if (value === null || value === undefined || value === '') {
                callback(); // 空值通过验证
              } else if (value <= 0) {
                callback(new Error('种次号必须大于 0')); // 非空且 <= 0 时提示错误
              } else {
                callback(); // 非空且 > 0 时通过
              }
            },
            trigger: 'blur',
          },
        ],
      },
      downloadLoading: false,
      xsSize: 24,
      smSize: 24,
      mdSize: 12,
      lgSize: 12,
      xlSize: 12,
      dialogTSCXVisible: false,
      dialogBGSWVisible: false,
      formModel: {
        StrCover: "",
      },
      picheaders: {},
      uploadtype: {
        type: 'image/bookcover'
      },
      myurl: BASE_URL + "books/",
      TSCXFormModel: {},
      formBGSWModel: {},
      swList: [],
      bookshelfs: [], // 根据书屋选择书架的
      sjAllList: [], // 所有书架
      activeName: "first",
      uploadUrl: "",
      fileList: [],
      Url: "",
      strBookshelfId: "",
      // 书标
      dialogVisibleSet: false,
      dialogVisible: false,
      formLableCode: {
        type: 1,
      },
      // 书标方案：1=种次号，2=著作号
      printScheme: '1',

      typeList: [
        {
          id: 1,
          label: "按编目顺序打印",
        },
        {
          id: 2,
          label: "按条码区间打印",
        },
        {
          id: 3,
          label: "按剔旧条码打印",
        },
      ],
      returnList: [
        {
          id: 0,
          label: "返回条数",
        },
        {
          id: 0,
          label: "返回数据",
        },
      ],
      batchList: [],
      batchTotal: null,
      // 设置
      formStyleSet: {},
      // 要打印的列表
      printList: [],
      // 垂直
      printSet: {
        gap:0,
        // 纸张宽度
        width: 210,
        //书标高度
        height: 297,
        // 书标区域
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        // 书标排版
        row: 10,
        col: 5,
        // 内容排列
        // 垂直
        verticalAlign: "center",
        // 水平
        horizontalAlign: "center",
        // 行高
        lineHeight: 18,
        // 字体大小
        fontSize: 14,
        overturn: '2',
        //学校自定义名称
        name: '',
        //位置
        location: '2',
        //学校自定义字体大小
        nameFontSize: 14,
        marginRight: 0,
        marginLeft: 0,
        //条码显示：1=显示，0=隐藏
        showBarcode: '1',
      },
      dialogVisiblePrint: false,
      // 预览
      preview: false,
      // 缩放
      scale: 100,
      // 图书编目传来的批号
      receiveStrLotNumber: "",
      //图片预览
      showPictureCardPreview: false,
      showImg: "",
      printListSize: 0,

      //点击查询时对应的json
      search: {
        DTStartCreatedDate: '', // 或 null
        DTEndCreatedDate: ''
      },

      //条码打印的data，最后一个按钮
      printListSizeBarCode: 0,
      dialogBarCodeVisible: false,
      // 索书号设置：1=种次号，2=著作号
      dialogCallNumVisible: false,
      callNumType: '1',
      dialogVisiblePrintCodeBar: false,
      // 预览
      previewBarCode: false,
      // 缩放
      scaleBarCode: 100,
      //表单验证
      ruleBarCode: {
        lirName: [
          {required: true, message: "请输入馆名称", trigger: "blur"},
        ],
        barCodeLen: [{required: true, message: "请输入条码长度", trigger: "blur"}],
        beginBarCode: [{required: true, message: "请填写开始条码", trigger: "blur"}],
        barCodeNum: [
          {required: true, message: "请输入条码个数", trigger: "blur"},
        ],
      },
      formBarCode: {},
      printListBarCode: {
        lirName: '',
        barCode: ''
      },
      // 垂直
      printSetBarCode: {
        // 纸张
        width: 210,
        // 条码
        barCodeHeight: 23,
        columns: 5,
        // 书标区域
        paddingLeft: 10,
        paddingTop: 5,
        paddingRight: 10,
        paddingBottom: 0,
        //间距
        marginLeft: 4,
        marginTop: 3,
        // 内容排列
        // 垂直
        verticalAlign: "center",
        // 水平
        horizontalAlign: "center",
        // 行高
        lineHeight: 18,
        // 字体大小
        fontSize: 16,

      },
    };
  },
  directives: {
    positiveNumber: {
      bind(el) {
        const input = el.querySelector('input');
        input.addEventListener('input', function () {
          let value = input.value.replace(/[^0-9]/g, '').replace(/^0+/, '');
          const num = Number(value);
          if (!value || num <= 0) {
            input.value = '';
          } else {
            input.value = value;
          }
          // 触发 v-model 更新
          input.dispatchEvent(new Event('input'));
        });
      },
    },
  },
  computed: {
    zhCn() {
      return zhCn
    },
    uploadDisabled: function () {
      if (this.fileList.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    printListFilter() {
      let data = [];
      // if (this.preview) {
      //   data = this.printList.slice(0, this.printSet.col * this.printSet.row);
      // } else {
      data = this.printList;
      // }
      return data;
    },

    printListFilterBarCode() {
      let data = [];
      let lenzero = "000000000000000000000";
      let barcodeNum;
      let currentlen;

      if (this.activeForm === 'form1') {
        barcodeNum = this.formBarCode.beginBarCode;
        this.printListSizeBarCode = this.formBarCode.barCodeNum;

        for (let i = 0; i < this.formBarCode.barCodeNum; i++) {
          data[i] = { lirName: '', barCode: '', img: '' };
          data[i].lirName = this.formBarCode.lirName;
          currentlen = barcodeNum.toString().length;
          data[i].barCode = lenzero.substring(0, this.formBarCode.barCodeLen - currentlen) + barcodeNum.toString();
          data[i].img = this.generateBarcodeDataURL(data[i].barCode);
          barcodeNum++;
        }
      } else if (this.activeForm === 'form2') {
        const barcodes = this.getBarcodesFromString(this.formAnother.anotherField);
        this.printListSizeBarCode = barcodes.length;
        console.log("多少条数据"+this.printListSize);
        for (let i = 0; i < barcodes.length; i++) {
          // if(barcodes[i].length > 8 || barcodes[i].length < 8) {
          //   ElMessage.error("条码长度不符合书屋规定长度！")
          //   return ;
          // }
          data[i] = { lirName: this.formAnother.libName, barCode: barcodes[i], img: '' };
          data[i].img = this.generateBarcodeDataURL(barcodes[i]);
        }
      }
      return data;
    }

  },

  unmounted() {
    localStorage.removeItem("StrLotNumber")
    localStorage.removeItem("StrBookshelfID")
  },
  async mounted() {
    this.uploadUrl = global.syOssUrl + '/upload2Oss'
    this.getSWList();
    const strLotNumber = localStorage.getItem("StrLotNumber")
    if (strLotNumber && strLotNumber !== "undefined" && strLotNumber !== "null"&& strLotNumber !== "") {
      this.listQuery.Search = {
        StrLotNumber: strLotNumber,
      }
    }
    //不会出现又查批号又查书架的情况
    const strBookshelfID = localStorage.getItem("StrBookshelfID")
    if (strBookshelfID && strBookshelfID !== "undefined" && strBookshelfID !== "null"&& strBookshelfID !== "") {
      this.listQuery.Search = {
        StrBookshelfID: strBookshelfID,
      }
    }
    await this.getList();

    this.getBatchNumber();
    if (localStorage.getItem("printSet") != null) {
      const saved = JSON.parse(localStorage.getItem("printSet"));
      this.printSet = Object.assign({}, this.printSet, saved);
    }
    // 从缓存的机构设置同步索书号方案（驱动表格索书号列与书标打印默认方案）
    this.syncPrintSchemeFromOrgSetting();

    // this.baseInfoReq(this.list[0].StrID);
    // this.paperCollection(this.list[0].StrISBN, this.list[0].StrOrganizationID);
    this.setTableHeight();
    // 监听窗口大小变化
    window.addEventListener('resize', this.setTableHeight);

    const id = this.$route.params.id;
    console.log("接收到的 ID:", id);
    if (id) {
      this.search.StrLibraryID = id;
      await this.handleFilter();
    }

    // this.getBookHouse();
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.setTableHeight);
  },
  methods: {
    // 本地生成条形码图片（dataURL），避免依赖外网 free-barcode.com
    generateBarcodeDataURL(value) {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, value, {
        format: "CODE128",   // 条码格式，支持全 ASCII，扫描枪通用
        width: 1.7,          // 窄条宽度（对应原 bc3=1.7）
        height: 50,          // 条码高度
        displayValue: false, // 文字由模板 {{ item.barCode }} 显示，不在图片内重复
        margin: 0,           // 对应原 bc5=0
        fontSize: 15,        // 对应原 bc8=15
        font: "Arial",       // 对应原 bc7=Arial
      });
      return canvas.toDataURL("image/png");
    },
    preventChineseComma(e) {
      // 如果按下的键为中文逗号，则阻止默认行为
      if (e.key === '，') {
        e.preventDefault();
      }
    },
    handlePaste(e) {
      // 对粘贴的文本先拦截并过滤掉中文逗号
      const clipboardData = e.clipboardData || window.clipboardData;
      let pastedData = clipboardData.getData('Text');
      if (pastedData.includes('，')) {
        e.preventDefault();
        pastedData = pastedData.replace(/，/g, '');
        // 将过滤后的内容插入到输入框中（这里简单处理为追加方式，复杂场景下可能需要计算光标位置）
        this.formAnother.anotherField += pastedData;
      }
    },
    getBarcodesFromString(barcodeString) {
      if (typeof barcodeString !== 'string') return [];
      // 将连续的中英文逗号替换为单个英文逗号
      const sanitized = barcodeString.replace(/[，,]+/g, ',');
      return sanitized
          .split(',')
          .map(barcode => barcode.trim())
          .filter(barcode => barcode.length > 0);
    },

    bookSearch() {
      if(this.formCXTSModel.keywords === '' || this.formCXTSModel.keywords === null || this.formCXTSModel.keywords === undefined)
      {
        return;
      }
      let originalKeywords = this.formCXTSModel.keywords;
      let cleaned = originalKeywords.replace(/-/g, '');

      if (/^\d+$/.test(cleaned)) {
        // 如果输入是纯数字（可能是 ISBN），调用 searchByISBN
        this.searchByISBN(cleaned);
      } else {
        // 如果输入包含非数字字符（可能是标题），调用 bookSearchByTitle
        this.bookSearchByTitle(originalKeywords);
      }
    },


    bookSearchByTitle(title)
    {
      const param = {
        Search: {
          StrPositiveTitle:title
        },
        OrderBy: "DTCreatedDate",
        intNotOn: "1",
        Sort: "-1",
        Page: this.cxjgQuery.Page,
        Perpage: this.cxjgQuery.Pager,
      };
      this.$axios({
        url: BASE_URL + "books/search",
        method: "post",
        data: JSON.stringify(param),
        //发送格式为json
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.cxjgLoading = false;
          this.cxjgList = res.data.msg;
          this.tsTotal = res.data.total;
        }
      });
      this.dialogCXJGVisible = true;
    },

    searchByISBN(isbn) {
      const param = {
        keyName: this.formCXTSModel.keyName,
        keywords: isbn,
      };
      this.$axios({
        url: BASE_URL + "system/isbn/" + param.keywords,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          console.log(res.data.msg);
          // 填充表单数据
          this.formModel.StrRemark = res.data.msg.Annotations;
          this.formModel.StrOtherResponsible = res.data.msg.OtherResponsible;
          this.formModel.StrSectionName = res.data.msg.SectionName;
          this.formModel.StrSectionNumber = res.data.msg.SectionNum;
          this.formModel.StrSeriesTitle = res.data.msg.SeriesTitle;
          this.formModel.StrPositiveTitle = res.data.msg.Title;
          this.formModel.StrLotNumber = this.StrLotNumber;
          this.formModel.StrLotNumberID = this.StrLotNumberID;
          this.formModel.StrSubtitle = res.data.msg.Subtitle;
          this.formModel.StrFirstResponsible = res.data.msg.Author;
          this.formModel.StrBinding = res.data.msg.Binding;
          this.formModel.StrNumberPages = res.data.msg.Page.toString();
          this.formModel.StrISBN = res.data.msg.ISBN;
          this.formModel.StrPublicationDate = res.data.msg.Pubdate;
          this.formModel.StrPublisherPlace = res.data.msg.Pubplace;
          this.formModel.StrPublisher = res.data.msg.Publisher;
          this.formModel.StrKeywords = res.data.msg.Keyword;
          this.formModel.StrTypeName = res.data.msg.Class;
          this.formModel.FloatPricePer = res.data.msg.Price;
          this.formModel.StrVersion = res.data.msg.Edition;
          this.formModel.StrSummary = res.data.msg.Summary;
          this.formModel.StrCoverURL = res.data.msg.Cover;

          // 处理封面图片
          this.fileList = [];
          this.checkImage(this.formModel.StrCoverURL)
              .then((result) => {
                if (result) {
                  this.fileList.push({ url: this.formModel.StrCoverURL });
                } else {
                  this.fileList.push({ url: require('../../assets/img/defaultBook.png') });
                }
              })
              .catch(() => {
                this.fileList.push({ url: require('../../assets/img/defaultBook.png') });
              });

          // 清空输入框
          this.formCXTSModel.keywords = '';
        } else {
          this.$notify({
            message: res.data.msg,
            type: "error",
            duration: 2000,
          });
        }
      }).catch(() => {
        this.$message({
          type: "error",
          message: "服务异常,请检查ISBN",
        });
      });
    },

    BookUpdate(row) {
      this.fileList = [];
      this.$axios({
        url: BASE_URL + "books/" + row.StrID,
        method: "get",
        //发送格式为json
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.formModel.StrRemark = res.data.msg.StrRemark;
          this.formModel.StrOtherResponsible = res.data.msg.StrOtherResponsible;
          this.formModel.StrSectionName = res.data.msg.StrSectionName;
          this.formModel.StrSectionNumber = res.data.msg.StrSectionNumber;
          this.formModel.StrSeriesTitle = res.data.msg.StrSeriesTitle;
          this.formModel.StrPositiveTitle = res.data.msg.StrPositiveTitle;
          this.formModel.StrLotNumber = this.StrLotNumber;
          this.formModel.StrLotNumberID = this.StrLotNumberID;
          this.formModel.StrSubtitle = res.data.msg.StrSubtitle;
          this.formModel.StrFirstResponsible = res.data.msg.StrFirstResponsible;
          this.formModel.StrBinding = res.data.msg.StrBinding;
          this.formModel.StrNumberPages = res.data.msg.StrNumberPages.toString();
          this.formModel.StrISBN = res.data.msg.StrISBN;
          this.formModel.StrPublicationDate = res.data.msg.StrPublicationDate;
          this.formModel.StrPublisherPlace = res.data.msg.StrPublisherPlace;
          this.formModel.StrPublisher = res.data.msg.StrPublisher;
          this.formModel.StrKeywords = res.data.msg.StrKeywords;
          this.formModel.StrTypeName = res.data.msg.StrTypeName;
          this.formModel.FloatPricePer = res.data.msg.FloatPricePer;
          this.formModel.StrVersion = res.data.msg.StrVersion;
          this.formModel.StrSummary = res.data.msg.StrSummary;
          this.formModel.StrCoverURL = res.data.msg.StrCoverURL;

          // 处理封面图片
          this.fileList = [];
          this.checkImage(this.formModel.StrCoverURL)
              .then((result) => {
                if (result) {
                  this.fileList.push({ url: this.formModel.StrCoverURL });
                } else {
                  this.fileList.push({ url: require('../../assets/img/defaultBook.png') });
                }
              })
              .catch(() => {
                this.fileList.push({ url: require('../../assets/img/defaultBook.png') });
              });

          // 清空输入框
          this.formCXTSModel.keywords = '';
        }
      });
      this.dialogCXJGVisible = false;
    },

    cxjgPageSizeChange(Perpage) {
      this.cxjgQuery.Perpage = Perpage;
      this.bookSearchByTitle(this.formCXTSModel.keywords);
    },
    cxjgCurrPageChange(Page) {
      this.cxjgQuery.Page = Page;
      this.bookSearchByTitle(this.formCXTSModel.keywords);
    },


    //TODO 扩展UI
    //TODO 请求opac数据，准备接数据显示
    //取消逻辑
    handleCancel(row) {
      console.log('取消', row.BookBarcode);
      if(row.AppointmentStatus === 3)
      {
        this.$message({
          message: '无法取消已取消的预约',
          type: 'warning'
        });
        return;
      }
      this.$confirm('是否取消该预约记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          StrID:row.StrID
        }
        this.$axios({
          url: BASE_URL + 'bookAppointmentRecord/cancel',
          method: 'post',
          data: JSON.stringify(param),
          headers: {
            'Content-Type': 'application/json',
            'dataType': 'json',
            'Authorization': localStorage.getItem("token")
          }
        }).then((res) => {
          if (res.data.ok) {
            this.$message({
              type: 'success',
              message: res.data.msg
            });
            this.bookingReq(this.pageCode)
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    async bookingReq(StrBookBarcode)
    {
      const reqData = {
        Page:this.bookingPage.currentPage,
        Perpage:this.bookingPage.pageSize,
        OrderBy:"DTCreatedDate",
        Search:{
          BookBarcode:StrBookBarcode
        }
      };
      await this.$axios({
        url: BASE_URL + "bookAppointmentRecord/search",
        method: "post",
        data: JSON.stringify(reqData),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      })
          .then(res => {
            this.bookingInfo = res.data.msg
            this.bookingPage.total = res.data.total;
          })
          .catch(error => {
            console.error("请求失败：", error);
          });

    },
    cleanData()
    {
      //当查询结果为空时，将数据清空
      this.opacInfo = [];
      this.borrowInfo = [];
      this.dueInfo = [];
      this.baseInfo = [];
      this.opacTotal = 0;
      this.borrowPage.total = 0;
      this.dueTotal = 0;
      this.url = require('../../assets/img/defaultBook.png');
    },
    setTableHeight() {
      // 获取浏览器窗口高度
      const windowHeight = window.innerHeight;
      // 假设其他元素（如头部和底部）高度总和为 100px
      const otherHeight = 100;
      // 计算表格高度
      if(windowHeight<750)
      {
        this.tableHeight = windowHeight/3;
      }else if(windowHeight<400)
      {
        this.tableHeight = windowHeight/4;
      }else if(windowHeight<300)
      {
        this.tableHeight = windowHeight/6;
      }
      else
      {
        this.tableHeight = windowHeight/2.5;
      }

    },
    //超期
    handleDeal(row)
    {
        this.fine = true;
        console.log(row.StrID);
        this.dueForm.StrID = row.StrID;
        this.dueForm.StrBookBarcode = row.StrBookBarcode;
    },
    fineandreturn(){
      const param={
        "FloatFineAmount":  this.dueForm.FloatFineAmount.toString()
      }
      this.$axios({
        url: BASE_URL + 'finerecords/'+ this.dueForm.StrID+'/amount',
        method: 'patch',
        data:JSON.stringify(param),
        //发送格式为json
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then((res) => {
        if (res.data.ok) {
          this.$message({
            message:"超期处理完成",
            type: 'success'
          })
          this.dueInfoReq(this.dueForm.StrBookBarcode)
          this.fine=false
        }else{
          this.$message({
            message:res.data.msg,
            type: 'error'
          })
        }
      })
    },
    async dueInfoReq(StrBookBarcode)
    {
      const reqData = {
        Page:1,
        Perpage:100,
        Sort:-1,
        OrderBy:{
          DTCreatedDate:-1,
          IntStatus:-1
        },
        Search:{
          StrFineReason:"Overdue",
          StrBookBarcode:StrBookBarcode
        }
      }

      await this.$axios({
        url: BASE_URL + "finerecords/search",
        method: "post",
        data: JSON.stringify(reqData),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      })
          .then(res => {
            this.dueInfo = res.data.msg
            this.dueTotal = res.data.total
          })
          .catch(error => {
            console.error("请求失败：", error);
          });
    },
    async handleSizeOpacChange(size)
    {
      this.opacPage.pageSize = size;
      await this.paperCollection(this.pageISBN)
    },
    async handlePageOpacChange(page)
    {
      this.opacPage.currentPage = page;
      await this.paperCollection(this.pageISBN)
    },


    async handleBookingSizeChange(size)
    {
      this.bookingPage.pageSize = size;
      await this.bookingReq(this.pageCode)
    },
    async handleBookingPageChange(page)
    {
      this.bookingPage.currentPage = page;
      await this.bookingReq(this.pageCode)
    },

    async handleSizeChange(size)
    {
      this.borrowPage.pageSize = size;
      await this.borrowInfoReq(this.pageCode)
    },
    async handlePageChange(page)
    {
      this.borrowPage.currentPage = page;
      await this.borrowInfoReq(this.pageCode)
    },
    async borrowInfoReq(StrBookBarcode)
    {
      const reqData = {
        Page:this.borrowPage.currentPage,
        Perpage:this.borrowPage.pageSize,
        Sort:"-1",
        OrderBy:"DTCreatedDate",
        Overdue:false,
        Search:{
          StrBookBarcode:StrBookBarcode
        }
      }

      await this.$axios({
        url: BASE_URL + "borrowrecords/search",
        method: "post",
        data: JSON.stringify(reqData),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      })
          .then(res => {
            this.borrowInfo = res.data.msg
            this.borrowPage.total = res.data.total
          })
          .catch(error => {
            console.error("请求失败：", error);
          });
    },
    async  paperCollection(ISBN)
    {
      const reqData = {
        intNotOn:"1",
        Page:this.opacPage.currentPage,
        PerPage:this.opacPage.pageSize,
        Sort: "-1",
        OrderBy:"DTCreatedDate",
        Search:{
          StrISBN:ISBN,
          // DTStartCreatedDate:"",
          // DTEndCreatedDate:""
        }
      }
      await this.$axios({
        url: BASE_URL + "books/search",
        method: "post",
        data: reqData,
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          'Authorization': localStorage.getItem("token")
        }
      })
          .then(res => {
            this.opacInfo = res.data.msg
            this.opacTotal = res.data.total
          })
          .catch(error => {
            console.error("请求失败：", error);
          });
    },
    handleEdit(row) {
      console.log("编辑", row);
      this.handleUpdate(row);
    },
    async handleRowClick(row) {
      this.pageCode = row.StrBookBarcode;
      this.pageISBN = row.StrISBN;
      console.log('点击了行数据:', row);
      this.isFull = true;
      this.srcList = []
      this.baseInfoReq(row.StrID)
      this.paperCollection(row.StrISBN)
      this.borrowInfoReq(row.StrBookBarcode)
      this.dueInfoReq(row.StrBookBarcode)
      this.bookingReq(row.StrBookBarcode);
    },
    async baseInfoReq(StrID)
    {
      try {
        const res = await this.$axios({
          url: BASE_URL + "books/" + StrID,
          method: "get",
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });
        if (res.data.ok) {
          this.baseInfo = res.data.msg;
          const coverUrl ='https://sanyue-oss-public.oss-cn-hangzhou.aliyuncs.com/image/bookcover/' +res.data.msg.StrISBN + '.jpg';
          console.log(coverUrl);
          if (coverUrl !== "") {
            const result = await this.checkImage(coverUrl);
            if (result) {
              // 图片路径可访问
              this.url = coverUrl;
              this.srcList.push(coverUrl);
            } else {
              // 图片路径无法访问，添加默认图片URL
              this.url = require('../../assets/img/defaultBook.png');
              this.srcList.push(require('../../assets/img/defaultBook.png'));
            }
          } else {
            this.url = require('../../assets/img/defaultBook.png');
            this.srcList.push(require('../../assets/img/defaultBook.png'));
          }
        } else {
          this.url = require('../../assets/img/defaultBook.png');
          this.srcList.push(require('../../assets/img/defaultBook.png'));
        }
      } catch (error) {
        console.error("请求出错:", error);
        this.url = require('../../assets/img/defaultBook.png');
        this.srcList.push(require('../../assets/img/defaultBook.png'));
      }
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key; // 更新activeIndex值
      console.log(key, keyPath);
    },
    fullScreen()
    {
      if(this.isFull === true)
      {
        this.isFull = false;
      }else {
        this.isFull = true;
      }
    },
    // 设置
    styleSet() {
    },
    disabledDate(time) {
      return time.getTime() > Date.now()
    },
    choose() {
      const day1 = new Date(this.search.DTStartCreatedDate)
      const day2 = new Date(this.search.DTEndCreatedDate)
      console.log(day1, day2)
      if (day2.getTime() < day1.getTime()) {
        ElMessage.error('日期选择错误')
        this.search.DTEndCreatedDate = ''
      }
    },


    checkSpecificKey(str) {
      var specialKey =
          "[`~!#$^&*()=|{}':;',\\[\\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
      for (var i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return true;
        }
      }
      return false;
    },
    check() {
      if (this.checkSpecificKey(this.formModel.StrTypeName)) {
        this.$message({
          message: "分类号不能包含.以外的其他符号,请检查分类号",
          type: "error",
        });
      }
    },
    //获取书屋列表
    getSWList() {
      this.$axios({
        url: BASE_URL + "librarys",
        method: "get",
        //发送格式为json
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.swList = res.data.msg;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 查询当前批号下的图书
    bookDataList(e) {
      var listQuery = {
        Page: 1,
        Perpage: 10,
        intNotOn: "1",
        Sort: "-1",
        OrderBy: "DTCreatedDate",
        Search: {
          StrLotNumber: e,
        },
      };
      this.$axios({
        url: BASE_URL + "books/search",
        method: "post",
        //发送格式为json
        data: JSON.stringify(listQuery),
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.total = res.data.total;
      });
      this.formLableCode.Start = null;
      this.formLableCode.End = null;
    },
    // 取消
    closeLableCode() {
      this.dialogVisible = false;
      this.dialogBarCodeVisible = false;
    },
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg.toLowerCase() === 'jpg'
      const extension2 = testmsg.toLowerCase() === 'jepg'
      const extension3 = testmsg.toLowerCase() === 'png'
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3) {
        this.$message({
          message: '上传图片只能是jpg/jepg/png格式!',
          type: 'warning'
        });
        return false
      }
      return new Promise((resolve, reject) => {
        this.now = Date.parse(new Date()) / 1000;
        this.picheaders = {
          'timestamp': this.now,
          'sign': md5('6486b66b41f8df68777eac23' + this.now)
        },
            new Compressor(file, {
              quality: 0.6, // 设置压缩质量，范围为 0 到 1，默认为 0.8
              success(result) {
                resolve(result);
              },
              error(err) {
                reject(err);
              },
            });
      });
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.showPictureCardPreview = true;
      this.showImg = file.url;
    },
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    // 上传图片成功
    handleSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.fileList = fileList
        this.formModel.StrCoverURL = response.msg
      }
    },
    // 上传图片移除
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.formModel.StrCoverURL = ''
    },
    //数据导出
    Download() {
      this.downloadLoading = true
      this.$axios({
        url: BASE_URL + "books/export",
        method: "post",
        //发送格式为json
        data: JSON.stringify(this.listQuery),
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'}); //处理文档流
        var data = new Date()
        let timem = data.getTime();
        const fileName = "图书档案" + timem + ".xlsx";
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    // 确定
    // labelCodeSure(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       if (this.formLableCode.type == 1) {
    //         this.formLableCode.OrderBy = "DTCreatedDate";
    //         this.formLableCode.Sort = "1";
    //         this.formLableCode.Start = parseInt(this.formLableCode.Start);
    //         this.formLableCode.End = parseInt(this.formLableCode.End);
    //       } else if (this.formLableCode.type == 2) {
    //         this.formLableCode.Start = null;
    //         this.formLableCode.End = null;
    //         this.formLableCode.OrderBy = "StrBookBarcode";
    //         this.formLableCode.Sort = "1";
    //       }
    //       this.$axios({
    //         url: BASE_URL + "books/printsearch",
    //         method: "post",
    //         //发送格式为json
    //         data: JSON.stringify(this.formLableCode),
    //         headers: {
    //           "Content-Type": "application/json",
    //           dataType: "json",
    //           Authorization: localStorage.getItem("token"),
    //         },
    //       }).then((res) => {
    //         if (res.data.ok) {
    //           this.printList = res.data.msg;
    //           this.printListSize = this.printList.length
    //           this.dialogVisiblePrint = true;
    //         } else {
    //           this.$message.error(res.data.msg)
    //         }
    //       });
    //     } else {
    //       if (this.formLableCode.type) {
    //         if (!this.formLableCode.StrLotNumber) {
    //           return false;
    //         }
    //         if (!this.batchTotal) {
    //           this.$message({
    //             type: "warning",
    //             message: "当前暂无数据可选",
    //           });
    //         }
    //       }
    //     }
    //   });
    // },
    labelCodeSure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formLableCode.type == 1) {
            this.formLableCode.OrderBy = "DTCreatedDate";
            this.formLableCode.Sort = "1";
            this.formLableCode.Start = parseInt(this.formLableCode.Start);
            this.formLableCode.End = parseInt(this.formLableCode.End);
          } else if (this.formLableCode.type == 2) {
            this.formLableCode.Start = null;
            this.formLableCode.End = null;
            this.formLableCode.OrderBy = "StrBookBarcode";
            this.formLableCode.Sort = "1";
          } else if(this.formLableCode.type == 3) {
            console.log("take a value:"+this.formAnother.bookMarkBarCode);
            const barcodes = this.getBarcodesFromString(this.formAnother.bookMarkBarCode);
            this.printList = []; // 初始化打印列表
            this.printListSize = 0; // 初始化打印列表大小

            // 循环遍历条码列表，并为每个条码发送请求
            Promise.all(barcodes.map(barcode => this.sendSinglePrintRequest(barcode)))
                .then((results) => {
                  const notFoundBarcodes = []; // 用于存储未找到的条码

                  results.forEach(res => {
                    const queriedBarcode = JSON.parse(res.config.data).Search.StrBookBarcode; // 获取当前查询的条码

                    if (res && res.data && res.data.ok && res.data.msg && res.data.msg.length > 0) {
                      this.printList = this.printList.concat(res.data.msg); // 合并结果
                      this.printListSize += res.data.msg.length;
                    } else {
                      notFoundBarcodes.push(queriedBarcode); // 将未找到的条码添加到数组
                      if (res && res.data && res.data.msg) {
                        console.error(`条码 ${queriedBarcode} 查询失败: ${res.data.msg}`);
                      } else {
                        console.error(`条码 ${queriedBarcode} 查询失败`);
                      }
                    }
                  });
                  if (notFoundBarcodes.length > 0) {
                    this.$message.warning(`以下条码未找到: ${notFoundBarcodes.join(', ')}`);
                  }else if(this.printListSize === 0){
                    this.$message.warning(`条码不存在！`)
                  }else {
                    this.dialogVisiblePrint = true; // 所有请求完成后显示对话框
                  }

                })
                .catch(() => {
                  this.$message.error("批量打印请求发生错误");
                  this.dialogVisiblePrint = false;
                });
            return ;
          }
          this.$axios({
            url: BASE_URL + "books/printsearch",
            method: "post",
            //发送格式为json
            data: JSON.stringify(this.formLableCode),
            headers: {
              "Content-Type": "application/json",
              dataType: "json",
              Authorization: localStorage.getItem("token"),
            },
          }).then((res) => {
            if (res.data.ok) {
              this.printList = res.data.msg;
              this.printListSize = this.printList.length
              this.dialogVisiblePrint = true;
            } else {
              this.$message.error(res.data.msg)
            }
          });
        } else {
          if (this.formLableCode.type) {
            if (!this.formLableCode.StrLotNumber) {
              return false;
            }
            if (!this.batchTotal) {
              this.$message({
                type: "warning",
                message: "当前暂无数据可选",
              });
            }
          }
        }
      });
    },

    sendSinglePrintRequest(barcode) {
      return this.$axios({
        url: BASE_URL + "books/search",
        method: "post",
        data: JSON.stringify({
          Page: 1,
          Perpage: 10,
          intNotOn: "1",
          Sort: "-1",
          OrderBy: "DTCreatedDate",
          Search: {
            StrBookBarcode: barcode
          }
        }),
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      });
    },
    // 批号编目
    getBatchNumber() {
      this.$axios({
        url: BASE_URL + "lotnumbers",
        method: "get",
        //发送格式为json
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.batchList = res.data.msg;
      });
    },
    // 书标条码打印
    btnPrint() {
      this.formLableCode.Start = '';
      this.formLableCode.StrLotNumber = '';
      this.formLableCode.StrEndBookBarcode = '';
      this.formLableCode.StrStartBookBarcode = '';
      // 每次打开时以机构设置为准
      this.syncPrintSchemeFromOrgSetting();
      this.dialogVisible = true;
    },
    // 从本地缓存的机构设置同步索书号方案：1=种次号，2=著作号
    syncPrintSchemeFromOrgSetting() {
      let orgSetting = null;
      try {
        orgSetting = JSON.parse(localStorage.getItem("orgSetting"));
      } catch (e) {
        orgSetting = null;
      }
      this.printScheme = (orgSetting && orgSetting.IntBookCallNumType === 2) ? '2' : '1';
    },
    //获取所有的图书
    getALLList() {
      this.listQuery = {
        Page: 1,
        Perpage: 10,
        intNotOn: "1",
        Sort: "-1",
        OrderBy: "DTCreatedDate",
      };
      localStorage.removeItem("StrLotNumber")
      localStorage.removeItem("StrBookshelfID")
      this.getList()
    },
    // 获取图书列表
    // getList() {
    //   this.dialogFormVisible = false;
    //   this.listLoading = true;
    //   // this.getlist(this.formModel).then(res => {
    //   this.$axios({
    //     url: BASE_URL + "books/search",
    //     method: "post",
    //     //发送格式为json
    //     data: JSON.stringify(this.listQuery),
    //     headers: {
    //       "Content-Type": "application/json",
    //       dataType: "json",
    //       Authorization: localStorage.getItem("token"),
    //     },
    //   }).then((res) => {
    //     if (res.data.ok) {
    //       this.list = res.data.msg;
    //       this.total = res.data.total;
    //       this.firstID = this.list[0].StrID;
    //       console.log('StrID', this.list[0].StrID);
    //
    //     } else {
    //       this.$message({
    //         message: res.data.msg,
    //         type: "error",
    //       });
    //     }
    //     this.listLoading = false;
    //   });
    // },
    getList() {
      this.dialogFormVisible = false;
      this.listLoading = true;
      // 返回 Promise，这样调用者就可以等待请求完成
      return this.$axios({
        url: BASE_URL + "books/search",
        method: "post",
        data: JSON.stringify(this.listQuery),
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.list = res.data.msg;
          this.total = res.data.total;
          if(this.total === 0){
            console.log('0');
            this.cleanData()
          }else {
            this.baseInfoReq(this.list[0].StrID);
            this.paperCollection(this.list[0].StrISBN);
            this.borrowInfoReq(this.list[0].StrBookBarcode);
            this.dueInfoReq(this.list[0].StrBookBarcode);
            this.bookingReq(this.list[0].StrBookBarcode);
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.listLoading = false;
      });
    },
    // 关闭dialog
    SWBGClose() {
      this.cancelBGSW();
    },
    // 取消dialog按钮
    cancelBGSW() {
      this.dialogBGSWVisible = false;
      this.formBGSWModel = {};
    },

    // 变更书屋
    btnUpdatePosition(row, boolean) {
      if (!this.dialogSJVisible) {
        this.dialogSJVisible = true;
        if (boolean) {
          this.formSJModel.StrBookID = row.StrID;
          // this.formSJModel.StrLibraryID=row.StrLibraryID
          // this.formSJModel.StrBookshelfID=row.StrBookshelfID
        } else {
          const strAarr = [];
          this.selectRows.forEach((item) => {
            strAarr.push(item.StrID);
          });
          this.formSJModel.StrBookID = strAarr.join(",");
        }
        this.$nextTick(() => {
          this.$refs["dataForm"].clearValidate();
        });
      } else {
        this.formSJModel.OnSelf = true;
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            this.$axios({
              url: BASE_URL + "books/onshelf",
              method: "post",
              data: JSON.stringify(this.formSJModel),
              //发送格式为json
              headers: {
                "Content-Type": "application/json",
                dataType: "json",
                Authorization: localStorage.getItem("token"),
              },
            }).then((res) => {
              if (res.data.ok) {
                this.$message({
                  message: "变更图书成功",
                  type: "success",
                });
                this.getList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
            this.formSJModel = {};
            this.dialogSJVisible = false;
          }
        });
      }
    },
    //删除图书
    BookDelete(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          url: BASE_URL + "books/" + row.StrID,
          method: "delete",
          //发送格式为json
          headers: {
            "Content-Type": "application/json",
            dataType: "json",
            Authorization: localStorage.getItem("token"),
          },
        }).then((res) => {
          if (res.data.ok) {
            this.$notify({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              message: res.data.msg,
              type: "error",
              duration: 5000,
            });
          }
          this.getList();
        });
      });
    },
    // 根据书屋名称查id
    swChange(val) {
      this.formSJModel.StrBookshelfID = null;
      this.swList.forEach((item) => {
        if (val === item.StrName) {
          this.formSJModel.StrLibraryID = item.StrID;
        }
      });
      this.getBookShelfList(this.formSJModel.StrLibraryID);
    },
    // 根据书屋获取书架
    getBookShelfList(val) {
      const param = {
        StrLibraryID: val,
      };
      this.$axios({
        url: BASE_URL + "bookshelfs",
        method: "post",
        data: JSON.stringify(param),
        //发送格式为json
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.bookshelfs = res.data.msg;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 添加
    handleCreate() {
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
    },
    //剔旧
    handleOutOld(row){
      console.log(row.StrID);
      const param = {
        StrID: row.StrID,
      }
      this.$confirm(`确定剔旧《${row.StrPositiveTitle}》吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          url: BASE_URL + "books/tickoutlodbook",
          method: "post",
          data:param,
          //发送格式为json
          headers: {
            "Content-Type": "application/json",
            dataType: "json",
            Authorization: localStorage.getItem("token"),
          },
        }).then((res) => {
          if (res.data.ok) {
            this.$notify({
              message: "剔旧成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              message: res.data.msg,
              type: "error",
              duration: 5000,
            });
          }
          this.getList();
        });
      });
    },
    // 编辑
    async handleUpdate(row) {
      this.formModel.StrLibraryID = "";
      this.formModel.StrBookshelfID = "";
      this.fileList = []
      console.log('刚进来图书信息....', this.fileList)
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      // const param = { strId: row.strId }
      this.getBookShelfList(row.StrLibraryID);
      const res = await this.$axios({
        url: BASE_URL + "books/" + row.StrID,
        method: "get",
        //发送格式为json
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      if (res.data.ok) {
        //对象
        this.formModel = res.data.msg;
        const coverUrl = res.data.msg.StrCoverURL;
        if (coverUrl !== "") {
          // this.fileList.push({
          //   url: res.data.msg.StrCoverURL,
          // });
          this.checkImage(coverUrl)
              .then((result) => {
                if (result) {
                  // 图片路径可访问
                  this.fileList.push({
                    url: coverUrl,
                  });
                } else {
                  // 图片路径无法访问，添加默认图片URL
                  this.fileList.push({
                    url: require('../../assets/img/defaultBook.png'),
                  });
                }
              })
              .catch(() => {
                // 图片路径检查出错，添加默认图片URL
                this.fileList.push({
                  url: require('../../assets/img/defaultBook.png'),
                });
              });
        } else {
          const imgsrc = 'https://sanyue-oss-public.oss-cn-hangzhou.aliyuncs.com/image/bookcover/' + res.data.msg.StrISBN + '.jpg'
          // this.fileList.push({
          //   url: 'https://sanyue-oss-public.oss-cn-hangzhou.aliyuncs.com/image/bookcover/' + res.data.msg.StrISBN + '.jpg',
          // });
          this.checkImage(imgsrc)
              .then((result) => {
                if (result) {
                  // 图片路径可访问
                  this.fileList.push({
                    url: imgsrc,
                  });
                } else {
                  // 图片路径无法访问，添加默认图片URL
                  this.fileList.push({
                    url: require('../../assets/img/defaultBook.png'),
                  });
                }
              })
              .catch(() => {
                // 图片路径检查出错，添加默认图片URL
                this.fileList.push({
                  url: require('../../assets/img/defaultBook.png'),
                });
              });
        }
        console.log('更换的图书信息....', this.fileList)
        //如果书借出了就去查询谁借阅了
        if (this.formModel.IsBorrowed) {
          // this.$axios({
          //   url: BASE_URL + "books/" + this.formModel.StrBookBarcode+"/reader",
          //   method: "get",
          //   //发送格式为json
          //   headers: {
          //     "Content-Type": "application/json",
          //     dataType: "json",
          //     Authorization: localStorage.getItem("token"),
          //   },
          // }).then((res) => {
          //   this.formModel.currentReaerName = res.data.msg.StrName;
          //   this.formModel.currentReaerNumber = res.data.msg.StrReaderCardNumber;
          // });
          this.borrowInfo = null;
          await this.borrowInfoReq(this.formModel.StrBookBarcode);
          const  unReturnBook = this.borrowInfo.find(item => item.IsReturn === false)
          console.log('未还数组'+unReturnBook.StrReaderName);
          this.formModel.currentReaerName = unReturnBook.StrReaderName
          this.formModel.currentReaerNumber = unReturnBook.StrReaderCardNumber
        }

        if (this.formModel.IsBorrowed) {
          this.formModel.IsBorrowed = "出借";
        } else {
          this.formModel.IsBorrowed = "在库";
        }

        if (this.formModel.IsBroken) {
          this.formModel.IsBroken = "已损毁";
        } else {
          this.formModel.IsBroken = "未损毁";
        }

        if (this.formModel.IsLost) {
          this.formModel.IsLost = "已丢失";
        } else {
          this.formModel.IsLost = "未丢失";
        }
        let swBool = false;
        let sjBool = false;
        // 书屋判断
        if (res.data.msg.strCollectionLocationId) {
          this.swList.forEach((item) => {
            if (item.StrID === res.data.msg.StrLibraryID) {
              swBool = true;
            }
          });
          if (!swBool) {
            this.formModel.StrLibraryID = "";
          } else {
            this.formModel.StrLibraryID = res.data.msg.StrLibraryID;
          }
        } else {
          this.formModel.StrLibraryID = res.data.msg.StrLibraryID;
        }
        // 书架判断
        if (this.sjList) {
          this.sjList.forEach((item) => {
            if (res.data.msg.StrBookshelfID === item.StrID) {
              sjBool = true;
            }
          });
        }
        if (!sjBool) {
          this.formSJModel.StrBookshelfID = "";
        }
      }
    },
    checkImage(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = function() {
          resolve(true); // 图片加载成功
        };
        img.onerror = function() {
          resolve(false); // 图片加载失败
        };
        img.src = url;
      });
    },
    // 查询
    handleFilter() {
      this.listQuery.Page = 1;
      this.listQuery.Perpage = 10;
      this.listLoading = true;

      // 如果 Search 不存在，则创建空对象，否则保留现有对象
      if (this.listQuery.Search === undefined) {
        this.listQuery.Search = {};
      }

      // 只在条件非空且非 undefined 时添加参数，并移除空参数
      if (this.search.StrISBN !== undefined && this.search.StrISBN !== '' && this.search.StrISBN !== null) {
        this.listQuery.Search["StrISBN"] = this.search.StrISBN;
      } else {
        delete this.listQuery.Search["StrISBN"]; // 如果为空，移除该参数
      }

      if (this.search.StrFirstResponsible !== undefined && this.search.StrFirstResponsible !== '' && this.search.StrFirstResponsible !== null) {
        this.listQuery.Search["StrFirstResponsible"] = this.search.StrFirstResponsible;
      } else {
        delete this.listQuery.Search["StrFirstResponsible"];
      }

      if (this.search.StrPositiveTitle !== undefined && this.search.StrPositiveTitle !== '' && this.search.StrPositiveTitle !== null) {
        this.listQuery.Search["StrPositiveTitle"] = this.search.StrPositiveTitle;
      } else {
        delete this.listQuery.Search["StrPositiveTitle"];
      }

      if (this.search.DTStartCreatedDate !== undefined && this.search.DTStartCreatedDate !== '' && this.search.DTStartCreatedDate !== null) {
        this.listQuery.Search["DTStartCreatedDate"] = this.search.DTStartCreatedDate;
      } else {
        delete this.listQuery.Search["DTStartCreatedDate"];
      }

      if (this.search.DTEndCreatedDate !== undefined && this.search.DTEndCreatedDate !== '' && this.search.DTEndCreatedDate !== null) {
        this.listQuery.Search["DTEndCreatedDate"] = this.search.DTEndCreatedDate;
      } else {
        delete this.listQuery.Search["DTEndCreatedDate"];
      }

      if (this.search.StrTypeName !== undefined && this.search.StrTypeName !== '' && this.search.StrTypeName !== null) {
        this.listQuery.Search["StrTypeName"] = this.search.StrTypeName;
      } else {
        delete this.listQuery.Search["StrTypeName"];
      }

      if (this.search.StrBookBarcode !== undefined && this.search.StrBookBarcode !== '' && this.search.StrBookBarcode !== null) {
        this.listQuery.Search["StrBookBarcode"] = this.search.StrBookBarcode;
      } else {
        delete this.listQuery.Search["StrBookBarcode"];
      }

      if (this.search.StrLibraryID !== undefined && this.search.StrLibraryID !== '' && this.search.StrLibraryID !== null) {
        this.listQuery.Search["StrLibraryID"] = this.search.StrLibraryID;
      } else {
        delete this.listQuery.Search["StrLibraryID"];
      }
      console.log('看看取得是什么值：'+this.search.StrLibraryID);
      this.listQuery.OrderBy = "DTCreatedDate";
      this.getList();
      this.dialogTSCXVisible = false;
    },
    // 图书修改确定
    updateData() {
      this.$refs.dataTsForm.validate(async (valid) => {
        if (valid) {
          //通过书屋信息查询书屋设置的条形码长度
          var strLibraryLength = await this.getBookcode(
              this.formModel.StrLibraryID
          );
          if (this.formModel.StrBookBarcode.length != strLibraryLength) {
            this.$message({
              type: "error",
              message: "条形码长度必须为" + strLibraryLength + "位",
            });
            return false;
          }
          this.formModel.FloatPricePer =
              this.formModel.FloatPricePer.toString();
          this.formModel.IntReservationRoyalty = parseInt(
              this.formModel.IntReservationRoyalty
          );
          this.formModel.IntMemoryCopyNum = parseInt(
              this.formModel.IntMemoryCopyNum
          );
          this.formModel.IntNumberCopies = parseInt(
              this.formModel.IntNumberCopies
          );
          if (this.formModel.IsBorrowed == "出借") {
            this.formModel.IsBorrowed = true;
          } else {
            this.formModel.IsBorrowed = false;
          }

          if (this.formModel.IsBroken == "已损毁") {
            this.formModel.IsBroken = true;
          } else {
            this.formModel.IsBroken = false;
          }

          if (this.formModel.IsLost == "已丢失") {
            this.formModel.IsLost = true;
          } else {
            this.formModel.IsLost = false;
          }
          if(this.formModel.StrBookNumber === '' || this.formModel.StrBookNumber === null || this.formModel.StrBookNumber === undefined) {
            this.formModel.StrBookNumber = '-1';
          }else {
            this.formModel.StrBookNumber = this.formModel.StrBookNumber
          }

          this.$axios({
            url: BASE_URL + "books/" + this.formModel.StrID,
            method: "patch",
            data: JSON.stringify(this.formModel),
            //发送格式为json
            headers: {
              "Content-Type": "application/json",
              dataType: "json",
              Authorization: localStorage.getItem("token"),
            },
          })
              .then((res) => {
                if (res.data.ok) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .catch();
          this.dialogFormVisible = false;
        } else {
          return false;
        }
      });
    },
    //根据书屋获取条形码长度
    async getBookcode(val) {
      const res = await this.$axios({
        url: BASE_URL + "librarys/" + val,
        method: "get",
        //发送格式为json
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      });
      if (res.data.ok) {
        return res.data.msg.IntBookBarcodeLength;
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    // 跳转单元
    gotoBookcatalog() {
      this.$router.push("/bookcatalog");
    },
    pageSizeChange(Perpage) {
      this.listQuery.Perpage = Perpage;
      this.getList();
    },
    currPageChange(Page) {
      this.listQuery.Page = Page;
      this.getList();
    },
    // 还原打印设置
    resetPrint() {
      localStorage.removeItem("printSet");
      this.printSet = {
        width: 210,
        height: 297,
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        col: 5,
        row: 10,
        verticalAlign: "center",
        horizontalAlign: "center",
        lineHeight: 18,
        fontSize: 14,
        overturn: '2',
        gap: 0,
        showBarcode: '1'
      };
    },
    // 书标打印索书号：种次号方案保持原逻辑；著作号方案优先取 StrCallNumber，
    // 无值则用 StrTypeName + "/" + StrAuthorNumber 拼接，如 A841/4723-1，
    // 若 StrAuxiliaryNum 非空再追加 ":" + StrAuxiliaryNum，如 A841/4723-1:2
    getPrintCallNumber(item) {
      if (this.printScheme === '2') {
        if (item.StrCallNumber) {
          return item.StrCallNumber;
        }
        const callNumber = item.StrTypeName + '/' + item.StrAuthorNumber;
        return item.StrAuxiliaryNum ? callNumber + ':' + item.StrAuxiliaryNum : callNumber;
      }else{
        const callNumber = item.StrTypeName + '/' + item.StrBookNumber;
        return item.StrAuxiliaryNum ? callNumber + ':' + item.StrAuxiliaryNum : callNumber;
      }
    },
    // 著作号方案预览和打印用：/ 后面的内容换行显示
    getPrintCallNumberHtml(item) {
      let callNumber;
      if (item.StrCallNumber) {
        callNumber = item.StrCallNumber;
      } else {
        callNumber = item.StrTypeName + '/' + item.StrAuthorNumber;
        if (item.StrAuxiliaryNum) {
          callNumber += ':' + item.StrAuxiliaryNum;
        }
      }
      const idx = callNumber.indexOf('/');
      if (idx === -1) {
        return callNumber;
      }
      return callNumber.substring(0, idx + 1) + '<br>' + callNumber.substring(idx + 1);
    },
    // 打印
    printTrue() {
      localStorage.setItem("printSet", JSON.stringify(this.printSet));
      this.preview = false;
      this.$nextTick(() => {
        this.$print(this.$refs.print);
      });
    },


    //***************按钮条码打印的方法区域**************
    // 打印
    printTrueBarCode() {
      this.previewBarCode = false;
      this.$nextTick(() => {
        this.$print(this.$refs.printBarCode);
      });
    },
    //还原条码打印设置
    resetPrintBarCode() {
      this.printSetBarCode = {
        width: 210,
        barCodeHeight: 23,
        columns: 5,
        // 书标区域
        paddingLeft: 10,
        paddingTop: 5,
        paddingRight: 10,
        paddingBottom: 0,
        //间距
        marginLeft: 4,
        marginTop: 3,
        // 内容排列
        // 垂直
        verticalAlign: "center",
        // 水平
        horizontalAlign: "center",
        // 行高
        lineHeight: 18,
        // 字体大小
        fontSize: 16,
      }
    },
    // 条码打印
    btnBarCodePrint() {
      this.formBarCode.lirName = '';
      this.formBarCode.barCodeLen = '';
      this.formBarCode.beginBarCode = '';
      this.formBarCode.barCodeNum = '';
      this.dialogBarCodeVisible = true
    },
    // 索书号设置（回显登录时缓存的机构设置）
    btnCallNumSet() {
      let orgSetting = null;
      try {
        orgSetting = JSON.parse(localStorage.getItem("orgSetting"));
      } catch (e) {
        orgSetting = null;
      }
      if (orgSetting && (orgSetting.IntBookCallNumType === 1 || orgSetting.IntBookCallNumType === 2)) {
        this.callNumType = String(orgSetting.IntBookCallNumType);
      } else {
        this.callNumType = '1';
      }
      this.dialogCallNumVisible = true;
    },
    // 索书号设置确定
    callNumSetSure() {
      const param = {
        IntBookCallNumType: parseInt(this.callNumType),
      };
      this.$axios({
        url: BASE_URL + "orgsettings/updateorgsetting",
        method: "post",
        data: JSON.stringify(param),
        //发送格式为json
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          // 后端返回的 msg 即为最新的机构设置，直接整体替换本地缓存
          if (res.data.msg) {
            localStorage.setItem("orgSetting", JSON.stringify(res.data.msg));
          }
          // 同步刷新表格索书号列及书标打印默认方案
          this.syncPrintSchemeFromOrgSetting();
          this.$message({
            message: "设置成功",
            type: "success",
          });
          this.dialogCallNumVisible = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // barCodeSure() {
    //   this.$refs['formBarCode'].validate((valid) => {
    //     if (valid) {
    //
    //       this.dialogBarCodeVisible = false;
    //       this.dialogVisiblePrintCodeBar = true;
    //
    //     } else {
    //       //???
    //       if (this.formLableCode.type) {
    //         if (!this.formLableCode.StrLotNumber) {
    //           return false;
    //         }
    //         if (!this.batchTotal) {
    //           this.$message({
    //             type: "warning",
    //             message: "当前暂无数据可选",
    //           });
    //         }
    //       }
    //     }
    //   });
    // },

    barCodeSure() {
      const formRef = this.activeForm === 'form1' ? 'formBarCode' : 'formAnother';
      this.$refs[formRef]?.validate((valid) => {
        if (valid) {
          // 在这里添加你的判断条件
          if (this.activeForm === 'form1') {
            // form1 校验通过后的逻辑
            this.dialogBarCodeVisible = false;
            this.dialogVisiblePrintCodeBar = true;
          } else if (this.activeForm === 'form2') {

            const barcodes = this.getBarcodesFromString(this.formAnother.anotherField);
            //长度判断
            // const validLengths = this.allBookBarcodeLengths; // 从 data 中获取所有允许的条码长度数组
            //
            // const hasInvalidLength = barcodes.some(barcode => {
            //   return !validLengths.includes(barcode.length);
            // });
            //
            // if (hasInvalidLength) {
            //   this.$message.error(`条码长度必须为 ${validLengths.join(' 或 ')} 位！`);
            //   return;
            // }
            if(barcodes.length === 0) {
              this.$message.error(`条码不能为空！`);
              return;
            }

            this.dialogBarCodeVisible = false;
            this.dialogVisiblePrintCodeBar = true;
          } else {
            // 处理其他 activeForm 值的情况，如果需要
            console.log("activeForm 的值为:", this.activeForm);
            this.$message.warning("未知的表单类型");
          }
        } else {
          this.$message.error("表单校验失败，请检查输入");
        }
      });
    },

    getBookHouse() {
      this.$axios({
        url: BASE_URL + 'librarys/search',
        method: 'post',
        data: JSON.stringify(this.listQuery),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          // res.data 包含了后端返回的完整数据对象
          console.log("后端返回的完整数据:", res.data);

          // res.data.msg 是包含书屋信息的数组
          const bookHouseList = res.data.msg;
          console.log("书屋列表:", bookHouseList);

          // res.data.total 是返回的书屋总数
          const totalBookHouses = res.data.total;
          console.log("书屋总数:", totalBookHouses);

          // 你可以将 bookHouseList 赋值给组件的 data 属性，以便在模板中使用
          this.bookHouseData = bookHouseList;
          this.totalBookHouseCount = totalBookHouses;
          // 可以在这里进行其他处理，例如显示成功消息
          // this.$message.success('成功获取书屋列表');

          const lengths = new Set();
          res.data.msg.forEach(library => {
            if (library.IntBookBarcodeLength !== undefined) {
              lengths.add(library.IntBookBarcodeLength);
            }
          });
          this.allBookBarcodeLengths = Array.from(lengths);
          console.log("所有允许的条码长度:", this.allBookBarcodeLengths);

          // if (this.allBookBarcodeLengths.length === 0) {
          //   this.$message.warning("未获取到有效的条码长度配置！");
          // }
        } else {
          // res.data.msg 可能包含错误信息
          console.error("获取书屋列表失败:", res.data.msg);
          this.$message.error('获取书屋列表失败');
        }
      }).catch(error => {
        console.error("请求书屋列表时发生错误:", error);
        this.$message.error('请求书屋列表时发生错误');
      });
    },

  },



};
</script>
<style scoped>

::v-deep .custom-header {
  font-size: 14px;
}

::v-deep .custom-table .cell {
  font-size: 12px;
}
::v-deep .book-table .cell {
  font-size: 12px;
  /** line-height: 30px;*/
  padding: 0px 8px; /* 调整单元格的内边距，例如4px上下，8px左右 */
  margin: 0; /* 清除单元格的外边距 */
  line-height: 1; /* 调整行内容的行高 */
}



::v-deep .book-table .el-table__row {
  height: 0px; /* 调整行高，例如30px */
}

::v-deep .book-table .el-table__cell {
  padding: 0px 8px; /* 调整单元格的内边距，例如4px上下，8px左右 */
  margin: 0; /* 清除单元格的外边距 */
}

::v-deep .book-table .el-table__body-wrapper tbody tr {
  line-height: 0; /* 调整行内容的行高 */
}



::v-deep .custom-table .el-table__row {
  height: 0px; /* 调整行高，例如30px */
}

::v-deep .custom-table .el-table__cell {
  padding: 0px 8px; /* 调整单元格的内边距，例如4px上下，8px左右 */
  margin: 0; /* 清除单元格的外边距 */
  line-height: 0px;
}

::v-deep .custom-table .el-table__body-wrapper tbody tr {
  line-height: 0; /* 调整行内容的行高 */
}

::v-deep .custom-table .el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


::v-deep .custom-table .el-button {
  padding: 0 !important;
  margin: 0 !important;
  height: 2px !important;
  line-height: 2px !important;
  min-height: 0 !important; /* 确保默认 min-height 不起作用 */
}
::v-deep .custom-table .el-button .el-button__inner {
  padding: 0 !important;
  margin: 0 !important;
  line-height: 2px !important;
}





::v-deep(.el-tabs__item) {
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  font-weight: 350;
  color: #333;
}



.image-text-container {
  display: flex;
  align-items: flex-start;
  gap: 35px;
  overflow: hidden;
}

/* 图片容器 */
/* 图片容器 */
.demo-image__preview {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 200px;
  height: 275px;
  border: 1px solid #ddd;
}

/* Element UI 图片样式 */
.el-image {
  /* 移除强制宽高 */
  /* width: 100% !important; */
  /* height: 100% !important; */
}

/* 图片本身 */
.el-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}



.text-column {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-size: 12px; /* 设置字体大小 */
  font-weight: normal; /* 设置字体粗细 */
  color: #333; /* 设置字体颜色 */
  /* 根据需要设置文字列的宽度、字体大小等 */
  max-width: 350px;
  min-width: 200px; /* 根据内容调整合适的最小宽度 */
  line-height: 1.8;
}

.text-column-right {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif; /* 设置字体族 */
  font-size: 12px; /* 设置字体大小 */
  font-weight: normal; /* 设置字体粗细 */
  color: #333; /* 设置字体颜色 */
  /* 根据需要设置文字列的宽度、字体大小等 */
  max-width: 350px;
  min-width: 200px; /* 根据内容调整合适的最小宽度 */
  line-height: 1.8;
  margin-left: 350px;
}


.disabled /deep/ .el-upload--picture-card {
  display: none;
}

.el-form--inline .el-form-item {
  margin-right: 0;
}

/*ul,li {*/
/*  list-style-type: none;*/
/*  padding: 0;*/
/*  margin: 0;*/
/*}*/
.print-set .print-set-item {
  padding: 5px;
  display: flex;
  align-items: center;
}

.print-set .print-set-item:nth-of-type(odd) {
  background-color: #fafbfc;
}

.print-set .print-set-item:nth-of-type(even) {
  background-color: #eef1f3;
}

.print-set .print-set-item .print-set-title {
  width: 80px;
  font-size: 16px;
  color: #555;
  font-weight: bold;
}

.print-set .print-set-item .print-set-option {
  width: 60px;
  padding: 0 6px;
  text-align: right;
}

.print-box {
  position: absolute;
  top: 0;
  left: 100%;
  background-color: #fff;
  transform-origin: 0 0;
  border-left: 1px solid #000;
}

.filter-container {
  /*border-top: 10px solid white;*/
  border-bottom: 10px solid white;
}

@media print {
  @page {
    margin: 0;  /* 移除默认边距 */
  }
}
</style>